///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2026
//                                    RXO Inc.
//                         All Rights Reserved Worldwide
//
// WARNING:  This program (or document) is unpublished, proprietary
// property of RXO Inc. and is to be maintained in strict confidence.
// Unauthorized reproduction, distribution or disclosure of this program
// (or document), or any program (or document) derived from it is
// prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { defineMessages } from "react-intl";

export default defineMessages({
  acc: {
    defaultMessage: "Acc",
    id: "acc"
  },
  accType: {
    defaultMessage: "Acc Type",
    id: "accType"
  },
  accept: {
    defaultMessage: "Accept",
    id: "accept"
  },
  accessDenied: {
    defaultMessage: "Access Denied",
    id: "accessDenied"
  },
  accessorials: {
    defaultMessage: "Accessorials",
    id: "accessorials"
  },
  accountName: {
    defaultMessage: "Account Name",
    id: "accountName"
  },
  accountOwnerOptional: {
    defaultMessage: "Account Owner (optional)",
    id: "accountOwnerOptional"
  },
  actions: {
    defaultMessage: "Actions",
    id: "actions"
  },
  activeBidsCount: {
    defaultMessage: "Active Bids ({activeBidsCount})",
    id: "activeBidsCount"
  },
  add: {
    defaultMessage: "Add",
    id: "add"
  },
  addAnother: {
    defaultMessage: "Add Another",
    id: "addAnother"
  },
  addAnyAdditionalDetailsToTheMatchesThatYouSelected: {
    defaultMessage:
      'Add any additional details to the matches that you selected, then click "{action}".',
    id: "addAnyAdditionalDetailsToTheMatchesThatYouSelected"
  },
  addCapSource: {
    defaultMessage: "Add Cap Source",
    id: "addCapSource"
  },
  addFee: {
    defaultMessage: "Add Fee",
    id: "addFee"
  },
  addNote: {
    defaultMessage: "Add Note",
    id: "addNote"
  },
  addPricingDetailsForTheCarriersSelectedUnderEachLane: {
    defaultMessage:
      'Add pricing details for the carrier(s) selected under each lane, then click "Finish".',
    id: "addPricingDetailsForTheCarriersSelectedUnderEachLane"
  },
  addSubmissionDetails: {
    defaultMessage: "Add Submission Details",
    id: "addSubmissionDetails"
  },
  addSubmissionPricing: {
    defaultMessage: "Add Submission Pricing",
    id: "addSubmissionPricing"
  },
  additionalCurrenciesOptional: {
    defaultMessage: "Additional Currencies (optional)",
    id: "additionalCurrenciesOptional"
  },
  additionalInformationOptional: {
    defaultMessage: "Additional Information (optional)",
    id: "additionalInformationOptional"
  },
  additionalModesWarningMessage: {
    defaultMessage:
      "Please return to the prior screen to select additional modes for award upload. If you continue with the current selection, the above mode(s) will be reported as Closed Lost.",
    id: "additionalModesWarningMessage"
  },
  additionalUser: {
    defaultMessage: "Additional User",
    id: "additionalUser"
  },
  admin: {
    defaultMessage: "Admin",
    id: "admin"
  },
  adminUser: {
    defaultMessage: "Admin User?",
    id: "adminUser"
  },
  seeAllActiveBids: {
    defaultMessage: "See All Bids?",
    id: "seeAllActiveBids"
  },
  adr: {
    defaultMessage: "ADR",
    id: "adr"
  },
  alert: {
    defaultMessage: "Alert",
    id: "alert"
  },
  all: {
    defaultMessage: "All",
    id: "all"
  },
  allColumnsSelected: {
    defaultMessage: "All Columns Selected",
    id: "allColumnsSelected"
  },
  analytics: {
    defaultMessage: "Analytics",
    id: "analytics"
    },
 annual: {
    defaultMessage: "Annual",
    id: "annual"
  },
  annualSpendOptional: {
    defaultMessage: "Annual Spend (optional)",
    id: "annualSpendOptional"
  },
  anotherImportInProgressMessage: {
    defaultMessage:
      "There is already another import in progress. Please wait till the previous import is complete!",
    id: "anotherImportInProgressMessage"
  },
  anotherRepriceInProgressMessage: {
    defaultMessage:
      "There is already another re-price in progress. Please wait till the previous re-price is complete!",
    id: "anotherRepriceInProgressMessage"
  },
  apply: {
    defaultMessage: "Apply",
    id: "apply"
  },
  applyMargin: {
    defaultMessage: "Apply Margin",
    id: "applyMargin"
  },
  applyMassMargin: {
    defaultMessage: "Apply Mass Margin",
    id: "applyMassMargin"
  },
  appointmentRequired: {
    defaultMessage: "Appointment Required",
    id: "appointmentRequired"
  },
  apr: {
    defaultMessage: "Apr",
    id: "apr"
  },
  archiveBid: {
    defaultMessage: "Archive Bid",
    id: "archiveBid"
  },
  archived: {
    defaultMessage: "Archived",
    id: "archived"
  },
  areYouSureYouAreReadyToSumbit: {
    defaultMessage: "Are you sure you are ready to submit?",
    id: "areYouSureYouAreReadyToSumbit"
  },
  areYouSureYouWantToClearExistingMatches: {
    defaultMessage: "Are you sure you want to clear existing matches?",
    id: "areYouSureYouWantToClearExistingMatches"
  },
  areYouSureYouWantToOverwriteMatches: {
    defaultMessage: "Are you sure you want to overwrite matches?",
    id: "areYouSureYouWantToOverwriteMatches"
  },
  areYouSureYouWouldLikeToProcess: {
    defaultMessage: "Are you sure you would like to proceed?",
    id: "areYouSureYouWouldLikeToProcess"
  },
  arrow: {
    defaultMessage: "Arrow",
    id: "arrow"
  },
  assetBasedPricingUser: {
    defaultMessage: "Asset Based Pricing User",
    id: "assetBasedPricingUser"
  },
  assetType: {
    defaultMessage: "Asset Type",
    id: "assetType"
  },
  assignLanes: {
    defaultMessage: "Assign Lanes",
    id: "assignLanes"
  },
  assigned: {
    defaultMessage: "Assigned",
    id: "assigned"
  },
  assignments: {
    defaultMessage: "Assignments",
    id: "assignments"
  },
  aToZ: {
    defaultMessage: "A to Z",
    id: "aToZ"
  },
  attachmentError: {
    defaultMessage: "Attachment Error",
    id: "attachmentError"
  },
  attachments: {
    defaultMessage: "Attachments",
    id: "attachments"
  },
  aug: {
    defaultMessage: "Aug",
    id: "aug"
  },
  autoTrailer: {
    defaultMessage: "Auto Trailer",
    id: "autoTrailer"
  },
  averageCost: {
    defaultMessage: "Average Cost",
    id: "averageCost"
  },
  averageCpm: {
    defaultMessage: "Average CPM",
    id: "averageCpm"
  },
  averageMargin: {
    defaultMessage: "Average Margin: {averageMargin}",
    id: "averageMargin"
  },
  avgCost: {
    defaultMessage: "Avg Cost",
    id: "avgCost"
  },
  avgCpKm: {
    defaultMessage: "Avg CPKm",
    id: "avgCpKm"
  },
  avgCpm: {
    defaultMessage: "Avg CPM",
    id: "avgCPM"
  },
  awardAcceptanceParameters: {
    defaultMessage: "Award Acceptance Parameters",
    id: "awardAcceptanceParameters"
  },
  awardDateOptional: {
    defaultMessage: "Award Date (optional)",
    id: "awardDateOptional"
  },
  awardDateMustNotBeAfterRateEffectiveDate: {
    defaultMessage: "Award date must be on or before rate effective date",
    id: "awardDateMustNotBeAfterRateEffectiveDate"
  },
  awardExportInProgressModalMessage: {
    defaultMessage:
      "We’re working on your export! This can take some time, however you can navigate to other parts of RFQ or even exit the page. We will notify you when your award export is complete.",
    id: "awardExportInProgressModalMessage"
  },
  awardImport: {
    defaultMessage: "Award Import",
    id: "awardImport"
  },
  awardImportCompleteMessage: {
    defaultMessage:
      "Awarded lanes were successfully imported. Would you like to close out the bid?",
    id: "awardImportCompleteMessage"
  },
  awardImportIncompleteMessage: {
    defaultMessage:
      "Shipper award document has been uploaded. Import awarded lanes into RFQ.",
    id: "awardImportIncompleteMessage"
  },
  awardImportInProgressModalMessage: {
    defaultMessage:
      "We’re working on your import! This can take some time, however you can navigate to other parts of RFQ or even exit the page. We will notify you when your award import is complete.",
    id: "laneExportInProgressModalMessage"
  },
  awardImportSuccessMesssage: {
    defaultMessage:
      "Thanks for your patience. Your award import is complete. You can update the awards or close out the bid from the pricing page.",
    id: "awardImportSuccessMesssage"
  },
  awardImportValidationMessage: {
    defaultMessage:
      "Uh oh, we ran into some errors. You can download a document highlighting the errors below. Please note that awards without errors have been successfully imported.",
    id: "awardImportValidationMessage"
  },
  awardRank: {
    defaultMessage: "Award Rank",
    id: "awardRank"
  },
  awardRate: {
    defaultMessage: "Award Rate",
    id: "awardRate"
  },
  awardType: {
    defaultMessage: "Award Type",
    id: "awardType"
  },
  awardUpload: {
    defaultMessage: "Award Upload",
    id: "awardUpload"
  },
  awardUploadForNonBidOwnerSuccessMessage: {
    defaultMessage:
      "Pricing will be notified to import awards into the system, and the bid will be archived. After that point, the bid can be found in Search.",
    id: "awardUploadForNonBidOwnerSuccessMessage"
  },
  awardUploadForSalesRepSuccessMessage: {
    defaultMessage:
      "The customer formatted award document has been uploaded. Please import award data into RFQ to complete the bid.",
    id: "awardUploadForSalesRepSuccessMessage"
  },
  awardUploadModalCheckboxMessage: {
    defaultMessage:
      "I have already shared the shipper award document in Attachments.",
    id: "awardUploadModalCheckboxMessage"
  },
  selfPricedAwardUploadStep1Title: {
    defaultMessage: "Award Upload",
    id: "selfPricedAwardUploadStep1Title"
  },
  selfPricedClosedWonDetailsTitle: {
    defaultMessage: "Closed Won Details",
    id: "selfPricedClosedWonDetailsTitle"
  },
  closedWonReasonLabel: {
    defaultMessage: "Closed Won Reason",
    id: "closedWonReasonLabel"
  },
  closedWonReasonPlaceholder: {
    defaultMessage: "Select a reason",
    id: "closedWonReasonPlaceholder"
  },
  closedWonReasonRequired: {
    defaultMessage: "Closed won reason is required.",
    id: "closedWonReasonRequired"
  },
  closedWonCommentsRequired: {
    defaultMessage: "Win comments are required.",
    id: "closedWonCommentsRequired"
  },
  winCommentsLabel: {
    defaultMessage: "Win Comments",
    id: "winCommentsLabel"
  },
  closedWonReasonCapabilitySolutionTechnology: {
    defaultMessage: "Capability / Solution / Technology",
    id: "closedWonReasonCapabilitySolutionTechnology"
  },
  closedWonReasonIncumbentIssues: {
    defaultMessage: "Incumbent Issues",
    id: "closedWonReasonIncumbentIssues"
  },
  closedWonReasonPrice: {
    defaultMessage: "Price",
    id: "closedWonReasonPrice"
  },
  closedWonReasonRelationship: {
    defaultMessage: "Relationship",
    id: "closedWonReasonRelationship"
  },
  closedWonReasonRxoPastPerformance: {
    defaultMessage: "RXO Past Performance",
    id: "closedWonReasonRxoPastPerformance"
  },
  selfPricedClosedWonSubmit: {
    defaultMessage: "Submit",
    id: "selfPricedClosedWonSubmit"
  },
  awardVol: {
    defaultMessage: "Award Vol",
    id: "awardVol"
  },
  awarded: {
    defaultMessage: "Awarded",
    id: "awarded"
  },
  awardsHaveBeenImportedMessage: {
    defaultMessage:
      "Awards have been imported. You can access the rate quote template here to upload rates.",
    id: "awardsHaveBeenImportedMessage"
  },
  awardsHaveBeenImportedRXOBidMessage: {
    defaultMessage:
      "Awards have been imported. You can access the FO award management template here to upload rates.",
    id: "awardsHaveBeenImportedRXOBidMessage"
  },
  awardsHaveBeenImportedShipperRatesMessage: {
    defaultMessage:
      "Awards have been imported. You can access the shipper rates template here to upload rates.",
    id: "awardHaveBeenImportedShipperRatesMessage"
  },
  back: {
    defaultMessage: "Back",
    id: "back"
  },
  backup: {
    defaultMessage: "Backup",
    id: "backup"
  },
  backupOnly: {
    defaultMessage: "Backup only",
    id: "backupOnly"
  },
  baseCost: {
    defaultMessage: "Base Cost",
    id: "baseCost"
  },
  baseRpKm: {
    defaultMessage: "Base RPKm",
    id: "baseRpKm"
  },
  baseRpm: {
    defaultMessage: "Base RPM",
    id: "baseRpm"
  },
  batchEdit: {
    defaultMessage: "Batch Edit",
    id: "batchEdit"
  },
  bcCity: {
    defaultMessage: "BC City",
    id: "bcCity"
  },
  bcCountry: {
    defaultMessage: "BC Country",
    id: "bcCountry"
  },
  bcFee: {
    defaultMessage: "BC Fee",
    id: "bcFee"
  },
  bcState: {
    defaultMessage: "BC State",
    id: "bcState"
  },
  beamTrailer: {
    defaultMessage: "Beam Trailer",
    id: "beamTrailer"
  },
  beginPricing: {
    defaultMessage: "Begin Pricing",
    id: "beginPricing"
  },
  bell: {
    defaultMessage: "Bell",
    id: "bell"
  },
  bid: {
    defaultMessage: "Bid",
    id: "bid"
  },
  bidCreator: {
    defaultMessage: "Bid Creator",
    id: "bidCreator"
  },
  bidDetailsOptional: {
    defaultMessage: "Bid Details (optional)",
    id: "bidDetailsOptional"
  },
  bidEndDate: {
    defaultMessage: "Bid End Date",
    id: "bidEndDate"
  },
  bidDeadlinePassedMessage: {
    defaultMessage:
      "The bid deadline has passed. Close bid or upload feedback.",
    id: "bidDeadlinePassedMessage"
  },
  bidClosedCannotReopenPastThirtyDays: {
    defaultMessage:
      "Bids cannot be re-opened if the Start Date is 30 days or more in the past.",
    id: "bidClosedCannotReopenPastThirtyDays"
  },
  bidHasBeenAddedToQueueMessage: {
    defaultMessage:
      "This bid has been added to your queue. You are the bid owner.",
    id: "bidHasBeenAddedToQueueMessage"
  },
  bidHasBeenArchivedMessage: {
    defaultMessage:
      "This bid has been archived. You can view this bid under Search.",
    id: "bidHasBeenArchivedMessage"
  },
  bidInformation: {
    defaultMessage: "Bid Information",
    id: "bidInformation"
  },
  bidName: {
    defaultMessage: "Bid Name",
    id: "bidName"
  },
  bidOutputFormats: {
    defaultMessage: "Bid Output Formats (optional)",
    id: "bidOutputFormats"
  },
  bidType: {
    defaultMessage: "Bid Type",
    id: "bidType"
  },
  bidWasRejectedForCarrierMatching: {
    defaultMessage: "Bid was rejected for carrier matching.",
    id: "bidWasRejectedForCarrierMatching"
  },
  bidScac: {
    defaultMessage: "Bid SCAC",
    id: "bidScac"
  },
  bidsIAmInTheTeam: {
    defaultMessage: "Bids I am in the Team",
    id: "bidsIAmInTheTeam"
  },
  bidsIHaveAssignments: {
    defaultMessage: "Bids I have Assignments",
    id: "bidsIHaveAssignments"
  },
  bidsIOwn: {
    defaultMessage: "Bids I Own",
    id: "bidsIOwn"
  },
  bidNotes: {
    defaultMessage: "Bid Notes",
    id: "bidNotes"
  },
  bidOwner: {
    defaultMessage: "Bid Owner",
    id: "bidOwner"
  },
  bidRejectedMessage: {
    defaultMessage:
      "This bid was rejected by {lastStatusChangeByUserName} on {date}.",
    id: "bidRejectedMessage"
  },
  bidStartDate: {
    defaultMessage: "Bid Start Date",
    id: "bidStartDate"
  },
  bidStatus: {
    defaultMessage: "Bid Status",
    id: "bidStatus"
  },
  bidStrategy: {
    defaultMessage: "Bid Strategy",
    id: "bidStrategy"
  },
  bidSuccessfullyUploadedMessage: {
    defaultMessage:
      "Your bid was successfully uploaded and sent to Pricing for review.",
    id: "bidSuccessfullyUploadedMessage"
  },
  bidViewErrorMessage: {
    defaultMessage:
      "Sorry, something failed to load. You can still access the bid, but please refresh at a later point.",
    id: "bidViewErrorMessage"
  },
  bingApi: {
    defaultMessage: "Bing Api",
    id: "bingApi"
   },
   both: {
    defaultMessage: "Both",
    id: "both"
  },
  boxcar: {
    defaultMessage: "Boxcar",
    id: "boxcar"
  },
  boxTrailer: {
    defaultMessage: "Box Trailer",
    id: "boxTrailer"
  },
  breakthrough: {
    defaultMessage: "Breakthrough",
    id: "breakthrough"
  },
  brokerToCarrierSpot: {
    defaultMessage: "Broker to Carrier Spot",
    id: "brokerToCarrierSpot"
  },
  brokerToCarrierTimeframe: {
    defaultMessage: "Broker to Carrier Timeframe",
    id: "brokerToCarrierTimeframe"
  },
  browse: {
    defaultMessage: "browse",
    id: "browse"
  },
  browser: {
    defaultMessage: "Browser",
    id: "browser"
  },
  bulk: {
    defaultMessage: "bulk",
    id: "bulk"
  },
  bulkLaneEdit: {
    defaultMessage: "Bulk Lane Edit",
    id: "bulkLaneEdit"
  },
  bulkLaneEditModalBodyMessage: {
    defaultMessage:
      "Select a populated RFQ template to bulk edit lanes. Matched lanes will bulk override differences in the Total Cost, Margin, FSC, and FSC Type columns.",
    id: "bulkLaneEditModalBodyMessage"
  },
  bulkLaneEditModalBodyMessageV2: {
    defaultMessage:
      "Select a populated RFQ template to bulk edit lanes. Matched lanes will bulk override differences in the Total Cost, Margin, FSC, FSC Type, Additional Fee and Strategic Quantile columns.",
    id: "bulkLaneEditModalBodyMessageV2"
  },
  bulkLaneEditModalBodyMessageV3: {
    defaultMessage:
      "Select a populated RFQ template to bulk edit lanes. Matched lanes will bulk override differences in the RXO USA TTT Cost Adjusted, RXO USA TTT CPM, RXO Adjusted Margin, RXO Margin %, Customer Fuel, Customer FSC Type, RXO Additional Fee, MX Cost, Strategic Quantile and Target columns.",
    id: "bulkLaneEditModalBodyMessageV3"
  },
  bulkLaneEditProgressMessage: {
    defaultMessage:
      "Please wait while we edit those lanes. Exiting this page or closing the browser will cause the bulk edit to fail.",
    id: "bulkLaneEditProgressMessage"
  },
  bulkLaneEditValidationMessage: {
    defaultMessage:
      "Uh oh, we ran into some errors. You can download a document highlighting the errors below. Please note that lanes without errors have been successfully edited.",
    id: "bulkLaneEditValidationMessage"
  },
  bulkMatching: {
    defaultMessage: "Bulk Matching",
    id: "bulkMatching"
  },
  bulkTanker: {
    defaultMessage: "Bulk & Tanker",
    id: "bulkTanker"
  },
  byExistingNowYouWillLoseAllOfTheInformationEntered: {
    defaultMessage:
      "By exiting now, you will lose all of the information entered.",
    id: "byExistingNowYouWillLoseAllOfTheInformationEntered"
  },
  cactusQuickbidOpportunity: {
    defaultMessage: "Cactus/Quickbid opportunity",
    id: "cactusQuickbidOpportunity"
  },
  carrier: {
    defaultMessage: "Carrier",
    id: "carrier"
  },
  carrierInfo: {
    defaultMessage: "Carrier Info",
    id: "carrierInfo"
  },
  carrierMatching: {
    defaultMessage: "Carrier Matching",
    id: "carrierMatching"
  },
  carrierName: {
    defaultMessage: "Carrier Name",
    id: "carrierName"
  },
  carrierRepViewReviewBannerMessage: {
    defaultMessage:
      "Carrier matches have been sent. Waiting for final review from procurement rep",
    id: "carrierRepViewReviewStateMessage"
  },
  carrierRelationsRepresentative: {
    defaultMessage: "Carrier Relations Representative",
    id: "carrierRelationsRepresentative"
  },
  carrierReps: {
    defaultMessage: "Carrier Reps",
    id: "carrierReps"
  },
  carrierSearchPlaceholder: {
    defaultMessage: "Search by Carrier Name, Code, or MC",
    id: "carrierSearchPlaceholder"
  },
  carriers: {
    defaultMessage: "Carriers",
    id: "carriers"
  },
  carrierCount: {
    defaultMessage: "{noOfCarriers} Carriers",
    id: "carrierCount"
  },
  calendar: {
    defaultMessage: "Calendar",
    id: "calendar"
  },
  canada: {
    defaultMessage: "Canada",
    id: "canada"
  },
  cancelledByUser: {
    defaultMessage: "Cancelled By User",
    id: "cancelledByUser"
  },
  cancel: {
    defaultMessage: "Cancel",
    id: "cancel"
  },
  cancelAndContinue: {
    defaultMessage: "Cancel & Continue",
    id: "cancelAndContinue"
  },
  capSource: {
    defaultMessage: "Cap Source",
    id: "capSource"
  },
  capacityMatchingProgressBannerMessage: {
    defaultMessage:
      "Capacity matching in progress. Please wait to begin reviewing carriers until complete!",
    id: "capacityMatchingProgressBannerMessage"
  },
  cashOnly: {
    defaultMessage: "Cash Only",
    id: "cashOnly"
  },
  check: {
    defaultMessage: "Check",
    id: "check"
  },
  checked: {
    defaultMessage: "Checked",
    id: "checked"
  },
  chevron: {
    defaultMessage: "Chevron",
    id: "chevron"
  },
  chooseFile: {
    defaultMessage: "choose file",
    id: "chooseFile"
  },
  cityName: {
    defaultMessage: "City Name",
    id: "cityName"
  },
  clearAndContinue: {
    defaultMessage: "Clear & Continue",
    id: "clearAndContinue"
  },
  clearFilters: {
    defaultMessage: "Clear Filters",
    id: "clearFilters"
  },
  clearSelectedMatches: {
    defaultMessage: "Clear selected matches",
    id: "clearSelectedMatches"
  },
  clearSelectedMatchesConfirmationMessage: {
    defaultMessage:
      "You selected Lane ID {laneId} for clearing existing matches. Are you sure you want to clear existing matches on this lane.",
    id: "clearSelectedMatchesConfirmationMessage"
  },
  clog: {
    defaultMessage: "Clog",
    id: "clog"
  },
  countryCode2: {
    defaultMessage: "Country",
    id: "countryCode2"
  },
  close: {
    defaultMessage: "Close",
    id: "close"
  },
  closeBid: {
    defaultMessage: "Close Bid",
    id: "closeBid"
  },
  closeBidModalBodyMessage: {
    defaultMessage:
      "Are you sure you want to close this bid? Closed lost bids must be completed in CRM.",
    id: "closeBidModalBodyMessage"
  },
  closeBidModalBodyMessageCoyote: {
    defaultMessage:
      "Are you sure you want to close this bid? You cannot re-open a bid once it has closed.",
    id: "closeBidModalBodyMessageCoyote"
  },
  closeBidModalBodyMessageWithCloseWon: {
    defaultMessage:
      "Are you sure you want to close this bid? You can close this bid as won or cancel to keep it open.",
    id: "closeBidModalBodyMessageWithCloseWon"
  },
  closeBidModalBodyMessageWithoutCloseWon: {
    defaultMessage:
      "Are you sure you want to close this bid? Closed lost bids must be completed in CRM.",
    id: "closeBidModalBodyMessageWithoutCloseWon"
  },
  closeWon: {
    defaultMessage: "CLOSE WON",
    id: "closeWon"
  },
  closeLostCrmSubmit: {
    defaultMessage: "Submit",
    id: "closeLostCrmSubmit"
  },
  closeLostDecisionLabel: {
    defaultMessage: "Closed Lost Decision",
    id: "closeLostDecisionLabel"
  },
  closeLostReasonLabel: {
    defaultMessage: "Closed Lost Reason",
    id: "closeLostReasonLabel"
  },
  lossCommentsLabel: {
    defaultMessage: "Loss Comments",
    id: "lossCommentsLabel"
  },
  closeLostCrmValidationRequired: {
    defaultMessage: "Loss comments are required.",
    id: "closeLostCrmValidationRequired"
  },
  closeLostDecisionCustomer: {
    defaultMessage: "Customer Decision",
    id: "closeLostDecisionCustomer"
  },
  closeLostDecisionRxo: {
    defaultMessage: "RXO Decision",
    id: "closeLostDecisionRxo"
  },
  closeLostReasonCustomerBidCanceledPostponed: {
    defaultMessage: "Bid Canceled / Postponed",
    id: "closeLostReasonCustomerBidCanceledPostponed"
  },
  closeLostReasonCustomerCapabilitySolutionTechnology: {
    defaultMessage: "Capability / Solution / Technology",
    id: "closeLostReasonCustomerCapabilitySolutionTechnology"
  },
  closeLostReasonCustomerContractualTerms: {
    defaultMessage: "Contractual terms",
    id: "closeLostReasonCustomerContractualTerms"
  },
  closeLostReasonCustomerNoRelationship: {
    defaultMessage: "No Relationship",
    id: "closeLostReasonCustomerNoRelationship"
  },
  closeLostReasonCustomerPrice: {
    defaultMessage: "Price",
    id: "closeLostReasonCustomerPrice"
  },
  closeLostReasonCustomerMarketStudy: {
    defaultMessage: "Market Study",
    id: "closeLostReasonCustomerMarketStudy"
  },
  closeLostReasonCustomerRiskOfChange: {
    defaultMessage: "Risk of Change",
    id: "closeLostReasonCustomerRiskOfChange"
  },
  closeLostReasonCustomerTimeConstraintsMissedDeadline: {
    defaultMessage: "Time Constraints/Missed Deadline",
    id: "closeLostReasonCustomerTimeConstraintsMissedDeadline"
  },
  closeLostReasonRxoCapabilitySolutionTechnology: {
    defaultMessage: "Capability / Solution / Technology",
    id: "closeLostReasonRxoCapabilitySolutionTechnology"
  },
  closeLostReasonRxoCapacity: {
    defaultMessage: "Capacity",
    id: "closeLostReasonRxoCapacity"
  },
  closeLostReasonRxoContractualTermsFinancialRisk: {
    defaultMessage: "Contractual Terms / Financial Risk",
    id: "closeLostReasonRxoContractualTermsFinancialRisk"
  },
  closeLostReasonRxoInternalResources: {
    defaultMessage: "Internal Resources",
    id: "closeLostReasonRxoInternalResources"
  },
  closeLostReasonRxoRelationship: {
    defaultMessage: "Relationship",
    id: "closeLostReasonRxoRelationship"
  },
  closeLostReasonRxoTimeConstraintsMissedDeadline: {
    defaultMessage: "Time Constraints/Missed Deadline",
    id: "closeLostReasonRxoTimeConstraintsMissedDeadline"
  },
  closeDate: {
    defaultMessage: "Close Date",
    id: "closeDate"
  },
  closeFullScreen: {
    defaultMessage: "Close Fullscreen",
    id: "closeFullScreen"
  },
  closed: {
    defaultMessage: "Closed",
    id: "closed"
  },
  clusters: {
    defaultMessage: "Clusters",
    id: "clusters"
  },
  code: {
    defaultMessage: "Code",
    id: "code"
  },
  columnChooser: {
    defaultMessage: "Column Chooser",
    id: "columnChooser"
  },
  competitorsOptional: {
    defaultMessage: "Competitors (optional)",
    id: "competitorsOptional"
  },
  commitmentAnnually: {
    defaultMessage: "Annually",
    id: "commitmentAnnually"
  },
  commitmentDaily: {
    defaultMessage: "Daily",
    id: "commitmentDaily"
  },
  commitmentMonthly: {
    defaultMessage: "Monthly",
    id: "commitmentMonthly"
  },
  commitmentPeriod: {
    defaultMessage: "Commitment Period:",
    id: "commitmentPeriod"
  },
  commitmentPeriodTooltip: {
    defaultMessage:
      "Note:  For a selected commitment period, volume on each lane will be recalculated to reflect the corresponding period.  e.g. 120 awarded volume on 1 lane, Monthly period selected, volume will reflect 10",
    id: "commitmentPeriodTooltip"
  },
  commitmentQuarterly: {
    defaultMessage: "Quarterly",
    id: "commitmentQuarterly"
  },
  commitmentWeekly: {
    defaultMessage: "Weekly",
    id: "commitmentWeekly"
  },
  conestoga: {
    defaultMessage: "Conestoga",
    id: "conestoga"
  },
  confirm: {
    defaultMessage: "Confirm",
    id: "confirm"
  },
  confirmCancellation: {
    defaultMessage: "Confirm Cancellation",
    id: "confirmCancellation"
  },
  confirmCancellationMessage: {
    defaultMessage:
      "Your changes have not been saved. If you exit, your changes will be lost. Are you sure you want to exit?",
    id: "confirmCancellationMessage"
  },
  confirmNavigation: {
    defaultMessage: "Confirm Navigation",
    id: "confirmNavigation"
  },
  contType: {
    defaultMessage: "Cont Type",
    id: "contType"
  },
  contactServiceDeskMessage: {
    defaultMessage: "Please contact Service Desk for support.",
    id: "contactServiceDesk"
  },
  container: {
    defaultMessage: "Container",
    id: "container"
  },
  containerSize: {
    defaultMessage: "Container Size",
    id: "containerSize"
  },
  continue: {
    defaultMessage: "Continue",
    id: "continue"
  },
  contractEffectiveEndDate: {
    defaultMessage: "Contract Effective End Date",
    id: "contractEffectiveEndDate"
  },
  contractEffectiveStartDate: {
    defaultMessage: "Contract Effective Start Date",
    id: "contractEffectiveStartDate"
  },
  contractTTTCost: {
    defaultMessage: "Contract TTT Cost",
    id: "contractTTTCost"
  },
  convertActiveNonPrimary: {
    defaultMessage: "Convert Active Non Primary",
    id: "convertActiveNonPrimary"
  },
  copyMatches: {
    defaultMessage: "Copy Matches",
    id: "copyMatches"
  },
  copyMatchesToLane: {
    defaultMessage: "Copy matches to lane",
    id: "copyMatchesToLane"
  },
  cost: {
    defaultMessage: "Cost",
    id: "cost"
  },
  costByEquipment: {
    defaultMessage: "Cost by Equipment",
    id: "costByEquipment"
  },
  costFrequency: {
    defaultMessage: "Cost Frequency",
    id: "costFrequency"
  },
  costOverTime: {
    defaultMessage: "Cost over Time",
    id: "costOverTime"
  },
  coyote: {
    defaultMessage: "Coyote",
    id: "coyote"
  },
  coyoteFleet: {
    defaultMessage: "Coyote Fleet",
    id: "coyoteFleet"
  },
  coyoteKm: {
    defaultMessage: "Coyote Km",
    id: "coyoteKm"
  },
  coyoteMi: {
    defaultMessage: "Coyote Mi",
    id: "coyoteMi"
  },
  coyoteMiles: {
    defaultMessage: "Coyote Miles",
    id: "coyoteMiles"
  },
  cpKm: {
    defaultMessage: "CPKm",
    id: "cpKm"
  },
  cpm: {
    defaultMessage: "CPM",
    id: "cpm"
  },
  cpKmFrequency: {
    defaultMessage: "CPKm Frequency",
    id: "cpKmFrequency"
  },
  cpmFrequency: {
    defaultMessage: "CPM Frequency",
    id: "cpmFrequency"
  },
  cpKmOverTime: {
    defaultMessage: "CPKm over Time",
    id: "cpKmOverTime"
  },
  cpmOverTime: {
    defaultMessage: "CPM over Time",
    id: "cpmOverTime"
  },
  createNewBid: {
    defaultMessage: "Create New Bid",
    id: "createNewBid"
  },
  createOpportunityInRevv: {
    defaultMessage: "Create Opportunity in REVV",
    id: "createOpportunityInRevv"
  },
  crossBorderMexico: {
    defaultMessage: "Cross Border – Mexico",
    id: "crossBorderMexico"
  },
  crossBorderOptional: {
    defaultMessage: "Cross Border (optional)",
    id: "crossBorderOptional"
  },
  crossBorderInvalidSelection: {
    defaultMessage: "Please select only one cross border option",
    id: "crossBorderInvalidSelection"
  },
  currency: {
    defaultMessage: "Currency",
    id: "currency"
  },
  custom: {
    defaultMessage: "Custom",
    id: "custom"
  },
  customerBranchAndNetworkTimeframeFrom: {
    defaultMessage: "Historical Data Timeframe From",
    id: "customerBranchAndNetworkTimeframeFrom"
  },
  customerBranchAndNetworkTimeframeTo: {
    defaultMessage: "Historical Data Timeframe To",
    id: "customerBranchAndNetworkTimeframeTo"
  },
  customerFeedback: {
    defaultMessage: "Customer Feedback",
    id: "customerFeedback"
  },
  customerFeedbackType: {
    defaultMessage: "Customer Feedback Type",
    id: "customerFeedbackType"
  },
  customerFuel: {
    defaultMessage: "Customer Fuel (optional)",
    id: "customerFuel"
  },
  customerFuelBare: {
    defaultMessage: "Customer Fuel",
    id: "customerFuelBare"
  },
  customerFscTotal: {
    defaultMessage: "Customer FSC Total",
    id: "customerFscTotal"
  },
  customerFscType: {
    defaultMessage: "Customer FSC Type",
    id: "customerFscType"
  },
  customerLaneId: {
    defaultMessage: "Customer Lane ID",
    id: "customerLaneId"
  },
  customerLinehaulRate: {
    defaultMessage: "Customer Linehaul Rate",
    id: "customerLinehaulRate"
  },
  customerLinehaulRpm: {
    defaultMessage: "Customer RPM",
    id: "customerLinehaulRpm"
  },
  customerMiles: {
    defaultMessage: "Customer Miles",
    id: "customerMiles"
  },
  customerStatusOptional: {
    defaultMessage: "Customer Status (optional)",
    id: "customerStatusOptional"
  },
  dat: {
    defaultMessage: "DAT",
    id: "dat"
  },
  datWebsite: {
    defaultMessage: "DAT website",
    id: "datWebsite"
  },
  datDisclaimer: {
    defaultMessage:
      "* Displayed data is based on the origin, destination, and equipment type specified. If a single equipment type is chosen, it will be reflected in the data. However, if multiple equipment types are entered, the data will default to the van (V).",
    id: "datDisclaimer"
  },
  date: {
    defaultMessage: "Date",
    id: "date"
  },
  dateAssigned: {
    defaultMessage: "Date Assigned",
    id: "dateAssigned"
  },
  dateAndTime: {
    defaultMessage: "Date and Time",
    id: "dateAndTime"
  },
  deadline: {
    defaultMessage: "Deadline",
    id: "deadline"
  },
  dec: {
    defaultMessage: "Dec",
    id: "dec"
  },
  deckedReefer: {
    defaultMessage: "Decked Reefer",
    id: "deckedReefer"
  },
  delete: {
    defaultMessage: "Delete",
    id: "delete"
  },
  deleteBidConfirmationMessage: {
    defaultMessage:
      'Deleting bid "{bidName}" is not reversible. It will delete all the associated data for this bid. Are you sure you want to take this action?',
    id: "deleteBidConfirmationMessage"
  },
  deleteDocument: {
    defaultMessage: "Delete Document",
    id: "deleteDocument"
  },
  deleteAllLanes: {
    defaultMessage: "Delete All Lanes",
    id: "deleteAllLanes"
  },
  deleteAllLanesConfirmationMessage: {
    defaultMessage: "Are you sure you want to delete all lanes?",
    id: "deleteAllLanesConfirmationMessage"
  },
  deleteDocumentConfirmationMessage: {
    defaultMessage: "Are you sure you want to delete this document?",
    id: "deleteDocumentConfirmationMessage"
  },
  deleteLane: {
    defaultMessage: "Delete Lane",
    id: "deleteLane"
  },
  deleteLaneConfirmationMessage: {
    defaultMessage: "Are you sure you want to delete this lane?",
    id: "deleteLaneConfirmationMessage"
  },
  destCarrier: {
    defaultMessage: "Dest Carrier",
    id: "destCarrier"
  },
  destCity: {
    defaultMessage: "Dest City",
    id: "destCity"
  },
  destCluster: {
    defaultMessage: "Dest Cluster",
    id: "destCluster"
  },
  destCountry: {
    defaultMessage: "Dest Country",
    id: "destCountry"
  },
  destDray: {
    defaultMessage: "Dest Dray",
    id: "destDray"
  },
  destDrayAccess: {
    defaultMessage: "Dest Dray Access",
    id: "destDrayAccess"
  },
  destDrayFuel: {
    defaultMessage: "Dest Dray Fuel",
    id: "destDrayFuel"
  },
  destDropTrailer: {
    defaultMessage: "Dest Drop Trailer",
    id: "destDropTrailer"
  },
  destLoadType: {
    defaultMessage: "Dest Load Type",
    id: "destLoadType"
  },
  destNotes: {
    defaultMessage: "Dest Notes",
    id: "destNotes"
  },
  destPlace: {
    defaultMessage: "Dest Place",
    id: "destPlace"
  },
  destPostal: {
    defaultMessage: "Dest Postal",
    id: "destPostal"
  },
  destRadius: {
    defaultMessage: "Dest Radius",
    id: "destRadius"
  },
  destRamp: {
    defaultMessage: "Dest Ramp",
    id: "destRamp"
  },
  destSt: {
    defaultMessage: "Dest St",
    id: "destSt"
  },
  destination: {
    defaultMessage: "Destination",
    id: "destination"
  },
  details: {
    defaultMessage: "Details",
    id: "details"
  },
  discounts: {
    defaultMessage: "Discounts",
    id: "discounts"
  },
  discountsOrMinimums: {
    defaultMessage: "Discounts / Minimums",
    id: "discountsOrMinimums"
  },
  distanceBasisOptional: {
    defaultMessage: "Distance Basis (optional)",
    id: "distanceBasisOptional"
  },
  division: {
    defaultMessage: "Division",
    id: "division"
  },
  documents: {
    defaultMessage: "Documents",
    id: "documents"
  },
  documentUpload: {
    defaultMessage: "Document Upload",
    id: "documentUpload"
  },
  documentUploadErrorMessage: {
    defaultMessage:
      "An error has occured while uploading. Please delete and try again.",
    id: "documentUploadErrorMessage"
  },
  documentUploadSuccessMessage: {
    defaultMessage:
      "Your documents have been uploaded. They can be accessed at any time in the Documents widget on the Summary page.",
    id: "documentUploadSuccessMessage"
  },
  doesNotMeetVolReq: {
    defaultMessage: "Does not meet volume requirements",
    id: "doesNotMeetVolReq"
  },
  done: {
    defaultMessage: "Done",
    id: "done"
  },
  dontHaveABidStrategy: {
    defaultMessage: "Don't have a bid strategy",
    id: "dontHaveABidStrategy"
  },
  doubleDrop: {
    defaultMessage: "Double Drop",
    id: "doubleDrop"
  },
  doubleMan: {
    defaultMessage: "Double Man",
    id: "doubleMan"
  },
  doubledeckBox: {
    defaultMessage: "Doubledeck Box",
    id: "doubledeckBox"
  },
  doubledeckFridge: {
    defaultMessage: "Doubledeck Fridge",
    id: "doubledeckFridge"
  },
  doubledeckTaut: {
    defaultMessage: "Doubledeck Taut",
    id: "doubledeckTaut"
  },
  download: {
    defaultMessage: "Download",
    id: "download"
  },
  downloadDocumentErrorMessage: {
    defaultMessage:
      "Sorry, something caused the download to fail. Please try again.",
    id: "downloadDocumentErrorMessage"
  },
  downloadDocument: {
    defaultMessage: "Download Document",
    id: "downloadDocument"
  },
  downloadErrorDocument: {
    defaultMessage: "Download Error Document",
    id: "downloadErrorDocument"
  },
  downloadFOTemplate: {
    defaultMessage: "Download FO Template",
    id: "downloadFOTemplate"
  },
  downloadTemplate: {
    defaultMessage: "Download Template",
    id: "downloadTemplate"
  },
  dropAndHook: {
    defaultMessage: "Drop&Hook",
    id: "dropAndHook"
  },
  dropFilesHereToUploadOr: {
    defaultMessage: "Drop files here to upload or ",
    id: "dropFilesHereToUploadOr"
  },
  dropFrame: {
    defaultMessage: "Drop Frame",
    id: "dropFrame"
  },
  dropOrLive: {
    defaultMessage: "Drop/Live",
    id: "dropOrLive"
  },
  dropOrDrop: {
    defaultMessage: "Drop/Drop",
    id: "dropOrDrop"
  },
  dropTrailer: {
    defaultMessage: "Drop Trailer",
    id: "dropTrailer"
  },
  dtdTransit: {
    defaultMessage: "DTD Transit",
    id: "dtdTransit"
  },
  dueDate: {
    defaultMessage: "Due: {formattedDate}",
    id: "dueDate"
  },
  duplicateDocument: {
    defaultMessage: "Duplicate Document",
    id: "duplicateDocument"
  },
  duplicateDocumentModalBodyMessage: {
    defaultMessage:
      "An identical document has already been uploaded in this bid. You can replace below existing document or cancel the upload.",
    id: "duplicateDocumentModalBodyMessage"
  },
  duraplateVan: {
    defaultMessage: "Duraplate Van",
    id: "duraplateVan"
  },
  earliestShip: {
    defaultMessage: "Earliest Ship",
    id: "earliestShip"
  },
  edit: {
    defaultMessage: "Edit",
    id: "edit"
  },
  editMatches: {
    defaultMessage: "Edit matches",
    id: "editMatches"
  },
  edited: {
    defaultMessage: "Edited",
    id: "edited"
  },
  editedLanesCount: {
    defaultMessage: "{editedLanesCount} Edited Lanes",
    id: "editedLanesCount"
  },
  effective: {
    defaultMessage: "Effective",
    id: "effective"
  },
  effectiveEndDate: {
    defaultMessage: "Effective End Date",
    id: "effectiveEndDate"
  },
  effectiveStartDate: {
    defaultMessage: "Effective Start Date",
    id: "effectiveStartDate"
  },
  email: {
    defaultMessage: "Email",
    id: "email"
  },
  endDate: {
    defaultMessage: "End Date",
    id: "endDate"
  },
  eq: {
    defaultMessage: "Eq",
    id: "eq"
  },
  eqCategory: {
    defaultMessage: "Eq Category",
    id: "eqCategory"
  },
  eqTypeDetails: {
    defaultMessage: "Eq Type Details",
    id: "eqTypeDetails"
  },
  equipment: {
    defaultMessage: "Equipment",
    id: "equipment"
  },
  equipType: {
    defaultMessage: "Equip. Type",
    id: "equipType"
  },
  equipmentType: {
    defaultMessage: "Equipment Type",
    id: "equipmentType"
  },
  error: {
    defaultMessage: "Error",
    id: "error"
  },
  escortOrTwic: {
    defaultMessage: "Escort or TWIC",
    id: "escortOrTwic"
  },
  eu: {
    defaultMessage: "EU",
    id: "eu"
  },
  euroliner: {
    defaultMessage: "Euroliner",
    id: "euroliner"
  },
  eutlFileName: {
    defaultMessage: "EU Truckload Lane Import Template.xlsx",
    id: "eutlFileName"
  },
  event: {
    defaultMessage: "Event",
    id: "event"
  },
  excel: {
    defaultMessage: "Excel",
    id: "excel"
  },
  exclamation: {
    defaultMessage: "Exclamation",
    id: "exclamation"
  },
  exclude: {
    defaultMessage: "Exclude",
    id: "exclude"
  },
  excludeAll: {
    defaultMessage: "Exclude All",
    id: "excludeAll"
  },
  executedContractOnFileOptional: {
    defaultMessage: "Executed Contract on File? (optional)",
    id: "executedContractOnFileOptional"
  },
  exit: {
    defaultMessage: "Exit",
    id: "exit"
  },
  expectedLPD: {
    defaultMessage: "Expected LPD",
    id: "expectedLPD"
  },
  expiration: {
    defaultMessage: "Expiration",
    id: "expiration"
  },
  export: {
    defaultMessage: "Export",
    id: "export"
  },
  exportCSV: {
    defaultMessage: "Export (CSV)",
    id: "exportCSV"
  },
  exportLanes: {
    defaultMessage: "Export Lanes",
    id: "exportLanes"
  },
  exportMatchesWarningMessage: {
    defaultMessage:
      "It's been more than 7 days since Matches were refreshed. Please refresh to export.",
    id: "exportMatchesWarningMessage"
  },
  extendibleFlatbed: {
    defaultMessage: "Extendible Flatbed",
    id: "extendibleFlatbed"
  },
  extendibleLowLoader: {
    defaultMessage: "Extendible Low Loader",
    id: "extendibleLowLoader"
  },
  feb: {
    defaultMessage: "Feb",
    id: "feb"
  },
  feedback: {
    defaultMessage: "Feedback",
    id: "feedback"
  },
  fileTypeNotSupportedMessage: {
    defaultMessage: "Error: File Type is not Supported",
    id: "fileTypeNotSupported"
  },
  filter: {
    defaultMessage: "Filter",
    id: "filter"
  },
  filters: {
    defaultMessage: "Filters",
    id: "filters"
  },
  finalSubmission: {
    defaultMessage: "Final Submission",
    id: "finalSubmission"
  },
  finalSubmissionConfirmationMessage: {
    defaultMessage:
      "Once you send your final submissions, a document will be created and you will no longer to make edits in this tab. Any edits will have to be made in the generated document.",
    id: "finalSubmissionConfirmationMessage"
  },
  financials: {
    defaultMessage: "Financials",
    id: "financials"
  },
  finish: {
    defaultMessage: "Finish",
    id: "finish"
  },
  finishedVehicleLogistics: {
    defaultMessage: "Finished Vehicle Logistics",
    id: "finishedVehicleLogistics"
  },
  firstName: {
    defaultMessage: "First Name",
    id: "firstName"
  },
  flatbed: {
    defaultMessage: "Flatbed",
    id: "flatbed"
  },
  flatbed48: {
    defaultMessage: "Flatbed 48",
    id: "flatbed48"
  },
  flatbed53: {
    defaultMessage: "Flatbed 53",
    id: "flatbed53"
  },
  flatbedStretch: {
    defaultMessage: "Flatbed Stretch",
    id: "flatbedStretch"
  },
  flatbedTwistlocks: {
    defaultMessage: "Flatbed+Twistlocks",
    id: "flatbedTwistlocks"
  },
  flatbedWithSides: {
    defaultMessage: "Flatbed with Sides",
    id: "flatbedWithSides"
  },
  flatbedWithTarp: {
    defaultMessage: "Flatbed with Tarp",
    id: "flatbedWithTarp"
  },
  flatCar: {
    defaultMessage: "Flat Car",
    id: "flatCar"
  },
  flatMarginPercentage: {
    defaultMessage: "Flat Margin Percentage",
    id: "flatMarginPercentage"
  },
  flatRate: {
    defaultMessage: "Flat Rate",
    id: "flatRate"
  },
  forecastedCost: {
    defaultMessage: "Forecasted Cost",
    id: "forecastedCost"
  },
  forecastedCpm: {
    defaultMessage: "Forecasted CPM",
    id: "forecastedCPM"
  },
  forecastedRange: {
    defaultMessage: "Forecasted Range",
    id: "forecastedRange"
  },
  forecastEndDate: {
    defaultMessage: "Forecast End Date",
    id: "forecastEndDate"
  },
  forecastStartDate: {
    defaultMessage: "Forecast Start Date",
    id: "forecastStartDate"
  },
  foCodes: {
    defaultMessage: "FO Codes",
    id: "foCodes"
  },
  foShipperCode: {
    defaultMessage: "FO Shipper Code",
    id: "foShipperCode"
  },
  freightClass: {
    defaultMessage: "Freight Class",
    id: "freightClass"
  },
  fscPeg: {
    defaultMessage: "FSC Peg",
    id: "fscPeg"
  },
  fscPegOptional: {
    defaultMessage: "FSC Peg (optional)",
    id: "fscPegOptional"
  },
  fscType: {
    defaultMessage: "FSC Type",
    id: "fscType"
  },
  fscTypeOptional: {
    defaultMessage: "FSC Type (optional)",
    id: "fscTypeOptional"
  },
  fscValue: {
    defaultMessage: "FSC Value",
    id: "fscValue"
  },
  fuel: {
    defaultMessage: "Fuel",
    id: "fuel"
  },
  fuelCost: {
    defaultMessage: "Fuel Cost",
    id: "fuelCost"
  },
  fuelRate: {
    defaultMessage: "Fuel Rate",
    id: "fuelRate"
  },
  general: {
    defaultMessage: "General",
    id: "general"
  },
  getStartedWithPricingAnalytics: {
    defaultMessage: "Get Started with Pricing Analytics",
    id: "getStartedWithPricingAnalytics"
  },
  gmpl: {
    defaultMessage: "GMPL",
    id: "gmpl"
  },
  goToBid: {
    defaultMessage: "Go To Bid",
    id: "goToBid"
  },
  green: {
    defaultMessage: "Green",
    id: "green"
  },
  group: {
    defaultMessage: "Group",
    id: "group"
  },
  hazMat: {
    defaultMessage: "HazMat",
    id: "hazMat"
  },
  hazmat: {
    defaultMessage: "Hazmat",
    id: "hazmat"
  },
  heatedVan: {
    defaultMessage: "Heated Van",
    id: "heatedVan"
  },
  help: {
    defaultMessage: "Help",
    id: "help"
  },
  hideRateHistory: {
    defaultMessage: "Hide Rate History",
    id: "hideRateHistory"
  },
  highValueOfCargoOptional: {
    defaultMessage: "High Value of Cargo (optional)",
    id: "highValueOfCargoOptional"
  },
  historicalCost: {
    defaultMessage: "Historical Cost",
    id: "historicalCost"
  },
  historicalCpm: {
    defaultMessage: "Historical CPM",
    id: "historicalCPM"
  },
  historicalLaneView: {
    defaultMessage: "Historical Lane View",
    id: "historicalLaneView"
  },
  historicalRange: {
    defaultMessage: "Historical Range",
    id: "historicalRange"
  },
  historicalShipperView: {
    defaultMessage: "Historical Shipper View",
    id: "historicalShipperView"
  },
  historicalVolumeByCPKm: {
    defaultMessage: "Historical Volume by CPKm",
    id: "historicalVolumeByCPKm"
  },
  historicalVolumeByCPM: {
    defaultMessage: "Historical Volume by CPM",
    id: "historicalVolumeByCPM"
  },
  historicalVolumeByCost: {
    defaultMessage: "Historical Volume by Cost",
    id: "historicalVolumeByCost"
  },
  home: {
    defaultMessage: "Home",
    id: "home"
  },
  hotShot: {
    defaultMessage: "Hot Shot",
    id: "hotShot"
  },
  hours24: {
    defaultMessage: "24 Hours",
    id: "hours24"
  },
  hours24To48: {
    defaultMessage: "24-48 Hours",
    id: "hours24To48"
  },
  hours48To1Week: {
    defaultMessage: "48 Hours - 1 Week",
    id: "hours48To1Week"
  },
  hrhv: {
    defaultMessage: "HRHV",
    id: "hrhv"
  },
  hundredweight: {
    defaultMessage: "Hundredweight (CWT)",
    id: "hundredweight"
  },
  hvhr: {
    defaultMessage: "HVHR",
    id: "hvhr"
  },
  hvhrPlus: {
    defaultMessage: "HVHR Plus",
    id: "hvhrPlus"
  },
  imdl: {
    defaultMessage: "IMDL",
    id: "IMDL"
  },
  imdlFileName: {
    defaultMessage: "Intermodal Lane Import Template.xlsx",
    id: "imdlFileName"
  },
  imdlPricing: {
    defaultMessage: "IMDL Pricing",
    id: "imdlPricing"
  },
  imdlPricingAnalyst: {
    defaultMessage: "IMDL Pricing Analyst",
    id: "imdlPricingAnalyst"
  },
  import: {
    defaultMessage: "Import",
    id: "import"
  },
  importAward: {
    defaultMessage: "Import Award",
    id: "importAward"
  },
  importLanes: {
    defaultMessage: "Import Lanes",
    id: "importLanes"
  },
  importYourLanesToBeginPricing: {
    defaultMessage: "Import your lanes to begin pricing",
    id: "importYourLanesToBeginPricing"
  },
  inboundToOutbound: {
    defaultMessage: "Inbound to Outbound",
    id: "inboundToOutbound"
  },
  include: {
    defaultMessage: "Include",
    id: "include"
  },
  includeAll: {
    defaultMessage: "Include All",
    id: "includeAll"
  },
  incmbtRate: {
    defaultMessage: "Incmbt Rate",
    id: "incmbtRate"
  },
  incumbent: {
    defaultMessage: "Incumbent",
    id: "incumbent"
  },
  incumbentCarrier: {
    defaultMessage: "Incumbent Carrier",
    id: "incumbentCarrier"
  },
  incumbentCarriers: {
    defaultMessage: "Incumbent Carriers",
    id: "incumbentCarriers"
  },
  incumbentCount: {
    defaultMessage: "{noOfIncumbentCarriers} Incumbent",
    id: "incumbentCount"
  },
  info: {
    defaultMessage: "Info",
    id: "info"
  },
  inProgress: {
    defaultMessage: "In Progress",
    id: "inProgress"
  },
  inside: {
    defaultMessage: "Inside",
    id: "inside"
  },
  intermodal: {
    defaultMessage: "Intermodal",
    id: "intermodal"
  },
  intermodalFridge: {
    defaultMessage: "Intermodal Fridge",
    id: "intermodalFridge"
  },
  internationalLanesOptional: {
    defaultMessage: "International Lanes (optional)",
    id: "internationalLanesOptional"
  },
  intraMx: {
    defaultMessage: "IntraMX",
    id: "intraMx"
  },
  invalidRouteMessage: {
    defaultMessage:
      "Sorry we can't find the page you're looking for. It may be temporarily unavailable, moved or no longer exists.",
    id: "invalidRoute"
  },
  invalidEmailAddress: {
    defaultMessage: "Invalid Email Address",
    id: "invalidEmailAddress"
  },
  invalidSalesforceIdLength: {
    defaultMessage: "Salesforce ID needs to have 18 characters.",
    id: "invalidSalesforceIdLength"
  },
  invalidSalesforceIdSpecialCharacters: {
    defaultMessage: "Salesforce ID should not contain special characters.",
    id: "invalidSalesforceIdSpecialCharacters"
  },
  isRXOUser: {
    defaultMessage: "Is RXO User",
    id: "isRXOUser"
  },
  jan: {
    defaultMessage: "Jan",
    id: "jan"
  },
  jul: {
    defaultMessage: "Jul",
    id: "jul"
  },
  jun: {
    defaultMessage: "Jun",
    id: "jun"
  },
  km: {
    defaultMessage: "Km",
    id: "km"
  },
  landall: {
    defaultMessage: "Landall",
    id: "landall"
  },
  lane: {
    defaultMessage: "Lane",
    id: "lane"
  },
  laneAssignments: {
    defaultMessage: "Lane Assignments",
    id: "laneAssignments"
  },
  laneAssignmentsErrorMessage: {
    defaultMessage:
      "Sorry, something went wrong with the lane assignments. Please try again. If you exit, lane assignments will not be saved.",
    id: "laneAssignmentsErrorMessage"
  },
  laneCount: {
    defaultMessage: "{noOfLanes} Lanes",
    id: "laneCount"
    },
  laneConversion: {
    defaultMessage: "Lane Conversion",
    id: "laneConversion"
  },
  laneForecast: {
    defaultMessage: "Lane Forecast",
    id: "laneForecast"
  },
  laneForecastEquipTypeInfoTooltip: {
    defaultMessage:
      "If a single equipment type is chosen, it will be reflected in the data. However, if multiple equipment types are entered, the data will default to the van (V).",
    id: "laneForecastEquipTypeInfoTooltip"
  },
  laneForecastInfoTooltip: {
    defaultMessage:
      "Lane Forecast Data shown to the right is based on the selected Forecasted Range.",
    id: "laneForecastInfoTooltip"
  },
  laneId: {
    defaultMessage: "Lane ID",
    id: "laneId"
  },
  laneImport: {
    defaultMessage: "Lane Import",
    id: "laneImport"
  },
  laneInImportProgressBannerMessage: {
    defaultMessage: "We are working on a lane import for this bid!",
    id: "laneInImportProgressBannerMessage"
  },
  laneInImportProgressModalMessage: {
    defaultMessage:
      "We’re working on your import! This can take up to 15 minutes, however you can navigate to other parts of RFQ or even exit the page. We will notify you when your lane import is complete.",
    id: "laneInImportProgressModalMessage"
  },
  laneInRepriceProgressBannerMessage: {
    defaultMessage: "Analyzing uploaded lanes and retrieving latest pricing.",
    id: "laneInRepriceProgressBannerMessage"
  },
  laneInitialPricingBannerMessage: {
    defaultMessage:
      "Analyzing uploaded lanes and retrieving pricing.",
    id: "laneInitialPricingBannerMessage"
  },
  laneMatch: {
    defaultMessage: "Lane Match",
    id: "laneMatch"
  },
  laneMatchCount: {
    defaultMessage: "Lane Match Count",
    id: "laneMatchCount"
  },
  laneType: {
    defaultMessage: "Lane Type",
    id: "laneType"
  },
  laneView: {
    defaultMessage: "Lane View",
    id: "laneView"
  },
  lanesAreMissingMatches: {
    defaultMessage: "{noOfLanes} lanes are missing matches.",
    id: "lanesAreMissingMatches"
  },
  lanesEdited: {
    defaultMessage: "Lanes Edited",
    id: "lanesEdited"
  },
  laneExportInProgressModalMessage: {
    defaultMessage:
      "We’re working on your export! This can take some time, however you can navigate to other parts of RFQ or even exit the page. We will notify you when your lane export is complete.",
    id: "laneExportInProgressModalMessage"
  },
  lanesHaveBeenImportedMessage: {
    defaultMessage:
      "Lanes have been imported. Submit a priced shipper document to complete pricing before {date}.",
    id: "lanesHaveBeenImportedMessage"
  },
  lanesSelected: {
    defaultMessage: "{noOfLanes} lanes selected",
    id: "lanesSelected"
  },
  lastEdited: {
    defaultMessage: "Last Edited",
    id: "lastEdited"
  },
  lastName: {
    defaultMessage: "Last Name",
    id: "lastName"
  },
  lastSaved: {
    defaultMessage: "Last Saved: {syncOn}",
    id: "lastSaved"
  },
  lastUpdate: {
    defaultMessage: "Last Update",
    id: "lastUpdate"
  },
  lessThanTruckload: {
    defaultMessage: "Less-than-truckload",
    id: "lessThanTruckload"
  },
  liftGate: {
    defaultMessage: "Lift Gate",
    id: "liftGate"
  },
  liquorPermit: {
    defaultMessage: "Liquor Permit",
    id: "liquorPermit"
  },
  limitedAccess: {
    defaultMessage: "Limited Access",
    id: "limitedAccess"
  },
  linehaul: {
    defaultMessage: "Linehaul",
    id: "linehaul"
  },
  linehaulAccess: {
    defaultMessage: "Linehaul Access",
    id: "linehaulAccess"
  },
  linehaulFuel: {
    defaultMessage: "Linehaul Fuel",
    id: "linehaulFuel"
  },
  liveOrDrop: {
    defaultMessage: "Live/Drop",
    id: "liveOrDrop"
  },
  liveOrLive: {
    defaultMessage: "Live/Live",
    id: "liveOrLive"
  },
  localTenderLeadTimeOptional: {
    defaultMessage: "Local Tender Lead Time (optional)",
    id: "localTenderLeadTimeOptional"
  },
  locationCode: {
    defaultMessage: "Location Code",
    id: "locationCode"
    },
  locations: {
    defaultMessage: "Locations",
    id: "locations"
  },
  locationSearchMinLength: {
    defaultMessage: "Enter at least 3 characters to search",
    id: "locationSearchMinLength"
  },
  locationSearchPlaceholder: {
    defaultMessage: "Search by city or zip",
    id: "locationSearchPlaceholder"
  },
  locationSearchResultCount: {
    defaultMessage: "{count} results",
    id: "locationSearchResultCount"
  },
  loadAttributes: {
    defaultMessage: "Load Attributes",
    id: "loadAttributes"
  },
  lost: {
    defaultMessage: "Lost",
    id: "lost"
  },
  logout: {
    defaultMessage: "Logout",
    id: "logout"
  },
  lanesImported: {
    defaultMessage: "Lanes Imported",
    id: "lanesImported"
  },
  latestDelivery: {
    defaultMessage: "Latest Delivery",
    id: "latestDelivery"
  },
  legacy: {
    defaultMessage: "Legacy",
    id: "legacy"
  },
  ltlImdl: {
    defaultMessage: "LTL & IMDL",
    id: "ltlImdl"
  },
  ftl: {
    defaultMessage: "FTL",
    id: "ftl"
  },
  loadId: {
    defaultMessage: "Load ID",
    id: "loadId"
  },
  loading: {
    defaultMessage: "Loading...",
    id: "loading"
  },
  lowLoader: {
    defaultMessage: "Low Loader",
    id: "lowLoader"
  },
  LPDGoal: {
    defaultMessage: "LPD Goal",
    id: "LPDGoal"
  },
  ltl: {
    defaultMessage: "LTL",
    id: "ltl"
  },
  ltlFileName: {
    defaultMessage: "Less than Truckload Lane Import Template.xlsx",
    id: "ltlFileName"
  },
  ltlPricing: {
    defaultMessage: "LTL Pricing",
    id: "ltlPricing"
  },
  ltlPricingAnalyst: {
    defaultMessage: "LTL Pricing Analyst",
    id: "ltlPricingAnalyst"
  },
  mainRep: {
    defaultMessage: "Main Rep",
    id: "mainRep"
  },
  manageUsers: {
    defaultMessage: "Manage Users",
    id: "manageUser"
  },
  manageUsersSuccessMessage: {
    defaultMessage: "Your changes have been saved.",
    id: "manageUsersSuccessMessage"
  },
  management: {
    defaultMessage: "Management",
    id: "management"
  },
  manualReprice: {
    defaultMessage: "Manual Re-price",
    id: "manualReprice"
  },
  mar: {
    defaultMessage: "Mar",
    id: "mar"
  },
  margin: {
    defaultMessage: "Margin",
    id: "margin"
  },
  marginExpectation: {
    defaultMessage: "Margin Expectation",
    id: "marginExpectation"
  },
  marginPct: {
    defaultMessage: "Margin Pct",
    id: "marginPct"
  },
  marginPercentWithSymbol: {
    defaultMessage: "Margin %",
    id: "marginPercentWithSymbol"
  },
  markAllAsRead: {
    defaultMessage: "Mark All As Read",
    id: "markAllAsRead"
  },
  markingAndTagging: {
    defaultMessage: "Marking and Tagging",
    id: "markingAndTagging"
  },
  matchDetails: {
    defaultMessage: "Match Details",
    id: "matchDetails"
  },
  matchInfo: {
    defaultMessage: "Match Info",
    id: "matchInfo"
  },
  matchOverwrite: {
    defaultMessage: "Match Overwrite",
    id: "matchOverwrite"
  },
  matches: {
    defaultMessage: "Matches",
    id: "matches"
    },
  marketStudy: {
    defaultMessage: "Market Study",
    id: "marketStudy"
  },
  maxFreightClass: {
    defaultMessage: "Max Freight Class",
    id: "maxFreightClass"
  },
  maximumMargin: {
    defaultMessage: "Maximum Margin",
    id: "maximumMargin"
  },
  maximumValue: {
    defaultMessage: "Maximum Value",
    id: "maximumValue"
  },
  maxVol: {
    defaultMessage: "Max Vol",
    id: "maxVol"
  },
  maxiFlatbed: {
    defaultMessage: "Maxi Flatbed",
    id: "maxiFlatbed"
  },
  maxiVan: {
    defaultMessage: "Maxi Van",
    id: "maxiVan"
  },
  may: {
    defaultMessage: "May",
    id: "may"
  },
  megatrailer: {
    defaultMessage: "Megatrailer",
    id: "megatrailer"
  },
  menu: {
    defaultMessage: "Menu",
    id: "menu"
  },
  messages: {
    defaultMessage: "Messages",
    id: "messages"
  },
  mexico: {
    defaultMessage: "Mexico",
    id: "mexico"
  },
  miles: {
    defaultMessage: "Miles",
    id: "miles"
  },
  mileage: {
    defaultMessage: "{mileage} mil.",
    id: "mileage"
  },
  minCost: {
    defaultMessage: "Min Cost",
    id: "minCost"
  },
  minRate: {
    defaultMessage: "Min Rate",
    id: "minRate"
  },
  minVol: {
    defaultMessage: "Min Vol",
    id: "minVol"
  },
  miniBid: {
    defaultMessage: "Mini Bid",
    id: "miniBid"
  },
  minimumMargin: {
    defaultMessage: "Minimum Margin",
    id: "minimumMargin"
  },
  minimumValue: {
    defaultMessage: "Minimum Value",
    id: "minimumValue"
  },
  mode: {
    defaultMessage: "Mode",
    id: "mode"
  },
  modeInformation: {
    defaultMessage: "Mode Information",
    id: "modeInformation"
  },
  month: {
    defaultMessage: "Month",
    id: "month"
  },
  months: {
    defaultMessage: "Months",
    id: "months"
    },
  monthly: {
    defaultMessage: "Monthly",
    id: "monthly"
  },
  monthRange: {
    defaultMessage: "Month Range",
    id: "monthRange"
  },
  moreInfoNeeded: {
    defaultMessage: "More information needed",
    id: "moreInfoNeeded"
  },
  moreThan1Week: {
    defaultMessage: "More than 1 Week",
    id: "moreThan1Week"
  },
  multimode: {
    defaultMessage: "Multimode",
    id: "multimode"
  },
  multiStop: {
    defaultMessage: "Multi-Stop",
    id: "multiStop"
  },
  mxCost: {
    defaultMessage: "MX Cost",
    id: "mxCost"
  },
  mxMiles: {
    defaultMessage: "MX Miles",
    id: "mxMiles"
  },
  name: {
    defaultMessage: "Name",
    id: "name"
  },
  navigationBlockerMessage: {
    defaultMessage:
      "You will lose your progress if you navigate away from the page. Are you sure you want to leave the page?",
    id: "navigationBlockerMessage"
  },
  networkAnnual: {
    defaultMessage: "Network Annual",
    id: "networkAnnual"
  },
  networkILA: {
    defaultMessage: "Network ILA",
    id: "networkILA"
  },
  networkQuarterly: {
    defaultMessage: "Network Quarterly",
    id: "networkQuarterly"
  },
  networkSemiAnnual: {
    defaultMessage: "Network Semi Annual",
    id: "networkSemiAnnual"
  },
  newBid: {
    defaultMessage: "New Bid",
    id: "newBid"
  },
  newBidAttachmentIntermodalMessage: {
    defaultMessage:
      "<b>Intermodal:</b> Shipper fuel schedule, Accessorials, average Dwell time",
    id: "newBidAttachmentIntermodalMessage"
  },
  newBidAttachmentLessThanTruckloadMessage: {
    defaultMessage: "<b> Less-than-truckload:</b> Shipment History",
    id: "newBidAttachmentLessThanTruckloadMessage"
  },
  newBidAttachmentUploadErrorMessage: {
    defaultMessage:
      "Sorry, we were unable to upload your attachments, however the rest of the bid has been successfully created. Please re-upload your files in the attachments widget on the bid page.",
    id: "newBidAttachmentUploadErrorMessage"
  },
  newBidSystemErrorMessage: {
    defaultMessage:
      "Sorry, something went wrong. Please try again or return to the form if you would like to make changes.",
    id: "newBidSystemErrorMessage"
  },
  newCarrierName: {
    defaultMessage: "New Carrier Name",
    id: "newCarrierName"
  },
  next: {
    defaultMessage: "Next",
    id: "next"
  },
  no: {
    defaultMessage: "No",
    id: "no"
  },
  noDatRateViewMessage: {
    defaultMessage:
      "Data for this particular lane, within the specific 3-digit zip geography and 90-day timeframe combination, is currently unavailable. Additional data may be available on the ",
    id: "noDatRateViewMessage"
  },
  noFlyZone: {
    defaultMessage: "No Fly Zone",
    id: "noFlyZone"
  },
  noLaneDataMessage: {
    defaultMessage: "There is no lane data that matches your criteria",
    id: "noLaneDataMessage"
  },
  noLaneMatchMessage: {
    defaultMessage: "There are no lanes that match your criteria",
    id: "noLaneMatchMessage"
  },
  noLanesAvailable: {
    defaultMessage: "No Lanes Available",
    id: "noLanesAvailable"
  },
  noMainRepresentativeOnFileForThisShipper: {
    defaultMessage: "No Main Representative on file for this shipper.",
    id: "noMainRepresentativeOnFileForThisShipper"
  },
  hasMatches: {
    defaultMessage: "Has Matches",
    id: "hasMatches"
  },
  noMatches: {
    defaultMessage: "No Matches",
    id: "noMatches"
  },
  noOptions: {
    defaultMessage: "No Options",
    id: "noOptions"
  },
  noResults: {
    defaultMessage: "No Results",
    id: "noResults"
  },
  noResultsFound: {
    defaultMessage: "No results found",
    id: "noResultsFound"
  },
  noShipperRatesDataMessage: {
    defaultMessage: "There are no rates that match your criteria",
    id: "noShipperRatesDataMessage"
  },
  noTargetType: {
    defaultMessage: "No Target Type",
    id: "noTargetType"
  },
  none: {
    defaultMessage: "None",
    id: "none"
  },
  notificationSettings: {
    defaultMessage: "Notification Settings",
    id: "notificationSettings"
  },
  notifications: {
    defaultMessage: "Notifications",
    id: "notifications"
  },
  notificationsCount: {
    defaultMessage: "Notifications ({noOfNotifications})",
    id: "notificationsCount"
  },
  note: {
    defaultMessage: "Note",
    id: "note"
  },
  notes: {
    defaultMessage: "Notes",
    id: "notes"
  },
  nov: {
    defaultMessage: "Nov",
    id: "nov"
  },
  noPendingBidsMessage: {
    defaultMessage: "Hooray! There are no new pending bids.",
    id: "noPendingBidsMessage"
  },
  numberOfAddStops: {
    defaultMessage: "Number Of Add Stops",
    id: "numberOfAddStops"
  },
  numberOfLanes: {
    defaultMessage: "Number of Lanes",
    id: "numberOfLanes"
  },
  numberOfRounds: {
    defaultMessage: "Number of Rounds",
    id: "numberOfRounds"
  },
  oct: {
    defaultMessage: "Oct",
    id: "oct"
  },
  onReceipt: {
    defaultMessage: "On receipt",
    id: "onReceipt"
  },
  opSurchargeAmt: {
    defaultMessage: "Op Surcharge Amt",
    id: "opSurchargeAmt"
  },
  openDeck: {
    defaultMessage: "Open Deck",
    id: "openDeck"
  },
  operations: {
    defaultMessage: "Operations",
    id: "operations"
  },
  oGroupOfficeOptional: {
    defaultMessage: "O Group Office (optional)",
    id: "oGroupOfficeOptional"
  },
  oGroupOptional: {
    defaultMessage: "O Group (optional)",
    id: "oGroupOptional"
  },
  ok: {
    defaultMessage: "Ok",
    id: "ok"
  },
  oops: {
    defaultMessage: "Oops!",
    id: "oops"
  },
  openDate: {
    defaultMessage: "Open Date",
    id: "openDate"
  },
  openFullScreen: {
    defaultMessage: "Open Fullscreen",
    id: "openFullScreen"
  },
  openNextRound: {
    defaultMessage: "Open Next Round",
    id: "openNextRound"
  },
  openNextRoundModalCheckboxMessage: {
    defaultMessage:
      "I have already shared the feedback document in Attachments.",
    id: "openNextRoundModalCheckboxMessage"
  },
  operationalCenter: {
    defaultMessage: "Operational Center",
    id: "operationalCenter"
  },
  opportunityCurrency: {
    defaultMessage: "Opportunity Currency",
    id: "opportunityCurrency"
  },
  opportunityLeaderOptional: {
    defaultMessage: "Opportunity Leader (optional)",
    id: "opportunityLeaderOptional"
  },
  opportunityLeader: {
    defaultMessage: "Opportunity Leader",
    id: "opportunityLeader"
  },
  directorOfCustomerSuccess: {
    defaultMessage: "Director of Customer Success",
    id: "directorOfCustomerSuccess"
  },
  opportunityName: {
    defaultMessage: "Opportunity Name",
    id: "opportunityName"
  },
  orDelete: {
    defaultMessage: "or delete.",
    id: "orDelete"
  },
  origCarrier: {
    defaultMessage: "Orig Carrier",
    id: "origCarrier"
  },
  origCity: {
    defaultMessage: "Orig City",
    id: "origCity"
  },
  origCluster: {
    defaultMessage: "Orig Cluster",
    id: "origCluster"
  },
  origCountry: {
    defaultMessage: "Orig Country",
    id: "origCountry"
  },
  origDray: {
    defaultMessage: "Orig Dray",
    id: "origDray"
  },
  origDrayAccess: {
    defaultMessage: "Orig Dray Access",
    id: "origDrayAccess"
  },
  origDrayFuel: {
    defaultMessage: "Orig Dray Fuel",
    id: "origDrayFuel"
  },
  origDropTrailer: {
    defaultMessage: "Orig Drop Trailer",
    id: "origDropTrailer"
   },
  origLoadType: {
    defaultMessage: "Orig Load Type",
    id: "origLoadType"
  },
  origNotes: {
    defaultMessage: "Orig Notes",
    id: "origNotes"
  },
  origPlace: {
    defaultMessage: "Orig Place",
    id: "origPlace"
  },
  origPostal: {
    defaultMessage: "Orig Postal",
    id: "origPostal"
  },
  origRamp: {
    defaultMessage: "Orig Ramp",
    id: "origRamp"
  },
  origSt: {
    defaultMessage: "Orig St",
    id: "origSt"
  },
  origin: {
    defaultMessage: "Origin",
    id: "origin"
  },
  originRadius: {
    defaultMessage: "Origin Radius",
    id: "originRadius"
  },
  other: {
    defaultMessage: "Other",
    id: "other"
  },
  ordinalNumberRound: {
    defaultMessage: "{ordinalNumber} Round",
    id: "ordinalNumberRound"
  },
  overDimension: {
    defaultMessage: "Over Dimension",
    id: "overDimension"
  },
   overDimensionalSpecialized: {
    defaultMessage: "Over Dimensional & Specialized",
    id: "overDimensionalSpecialized"
  },
  overwriteAndContinue: {
    defaultMessage: "Overwrite & Continue",
    id: "overwriteAndContinue"
  },
  overwriteMatchesConfirmationMessage: {
    defaultMessage:
      "You included Lane ID(s) {laneIds} in your match copying. Are you sure you want to overwrite existing matches on this lane.",
    id: "overwriteMatchesConfirmationMessage"
  },
  pageFailedToLoadMessage: {
    defaultMessage: "Sorry, the page failed to load. Please try again.",
    id: "pageFailedToLoadMessage"
  },
  paginationInfo: {
    defaultMessage: "{offset} - {limit} of {total}",
    id: "paginationInfo"
  },
  pageNotFound: {
    defaultMessage: "404 - Page Not Found",
    id: "pageNotFound"
  },
  palletExchange: {
    defaultMessage: "Pallet Exchange",
    id: "palletExchange"
  },
  palletJack: {
    defaultMessage: "Pallet Jack",
    id: "palletJack"
  },
  palletRating: {
    defaultMessage: "Pallet Rating ($ / Plt)",
    id: "palletRating"
  },
  palletsStackable: {
    defaultMessage: "Pallets Stackable",
    id: "palletsStackable"
  },
  partial: {
    defaultMessage: "Partial",
    id: "partial"
  },
  pcMiler: {
    defaultMessage: "PC Miler",
    id: "pcMiler"
  },
  pdf: {
    defaultMessage: "Pdf",
    id: "pdf"
  },
  pending: {
    defaultMessage: "Pending",
    id: "pending"
  },
  pendingBids: {
    defaultMessage: "Pending Bids",
    id: "pendingBids"
  },
  pendingFinalReview: {
    defaultMessage: "Pending Final Review",
    id: "pendingFinalReview"
  },
  pendingProcurementReview: {
    defaultMessage: "Pending Procurement Review",
    id: "pendingProcurementReview"
  },
  perDiem: {
    defaultMessage: "Per Diem",
    id: "perDiem"
  },
  perMileRate: {
    defaultMessage: "Per Mile Rate",
    id: "perMileRate"
  },
  percentage: {
    defaultMessage: "Percentage",
    id: "percentage"
  },
  percentOfLaneVolume: {
    defaultMessage: "% of Lane Volume",
    id: "percentOfLaneVolume"
  },
  percentOfRate: {
    defaultMessage: "% of Rate",
    id: "percentOfRate"
  },
  permit: {
    defaultMessage: "Permit",
    id: "permit"
  },
  picture: {
    defaultMessage: "Picture",
    id: "picture"
  },
  pleaseEnter3OrMoreCharacters: {
    defaultMessage: "Please enter 3 or more characters",
    id: "pleaseEnter3OrMoreCharacters"
  },
  pleaseFillOutTheSearchCriteria: {
    defaultMessage: "Please fill out the search criteria",
    id: "pleaseFillOutTheSearchCriteria"
  },
  pleaseRefreshTheBrowser: {
    defaultMessage: "Please refresh the browser",
    id: "pleaseRefreshTheBrowser"
  },
  pleaseRefreshThePage: {
    defaultMessage: "Please refresh the page",
    id: "pleaseRefreshThePage"
  },
  pleaseRefreshTheWidget: {
    defaultMessage: "Please refresh the widget",
    id: "pleaseRefreshTheWidget"
  },
  pleaseRefreshToContinueWithLaneAssignments: {
    defaultMessage: "Please refresh to continue with lane assignments.",
    id: "pleaseRefreshToContinueWithLaneAssignments"
  },
  pleaseSelectALaneCustomerCarrier: {
    defaultMessage: "Please select a lane, customer, or carrier",
    id: "pleaseSelectALaneCustomerCarrier"
  },
  pleaseSelectTheModesWithAwardsToUpload: {
    defaultMessage: "Please select the modes with awards to upload.",
    id: "pleaseSelectTheModesWithAwardsToUpload"
  },
  pointToPoint: {
    defaultMessage: "Point to Point",
    id: "pointToPoint"
  },
  pointToRegion: {
    defaultMessage: "Point to Region",
    id: "pointToRegion"
  },
  pointToState: {
    defaultMessage: "Point to State",
    id: "pointToState"
  },
  powerOnly: {
    defaultMessage: "Power Only",
    id: "powerOnly"
  },
  powerOnlyTraction: {
    defaultMessage: "Power Only Traction",
    id: "powerOnlyTraction"
  },
  preferredCarriersOptional: {
    defaultMessage: "Preferred Carriers (optional)",
    id: "preferredCarriersOptional"
  },
  previous: {
    defaultMessage: "Previous",
    id: "previous"
  },
  previousSalesforceOpportunityIdOptional: {
    defaultMessage: "Previous Salesforce Opportunity Id (optional)",
    id: "previousSalesforceOpportunityIdOptional"
  },
  prevContractTTTCost: {
    defaultMessage: "Prev Contract TTT Cost",
    id: "prevContractTTTCost"
  },
  prevTTTCost: {
    defaultMessage: "Prev TTT Cost",
    id: "prevTTTCost"
  },
  postalCode: {
    defaultMessage: "Postal Code",
    id: "postalCode"
  },
  priceMyself: {
    defaultMessage: "Price Myself",
    id: "priceMyself"
  },
  pricedBidSubmission: {
    defaultMessage: "Priced Bid Submission",
    id: "pricedBidSubmission"
  },
  pricing: {
    defaultMessage: "Pricing",
    id: "pricing"
  },
  pricingDueDate: {
    defaultMessage: "Pricing Due Date: {formattedDate}",
    id: "pricingDueDate"
  },
  pricingDueDateWithoutDate: {
    defaultMessage: "Pricing Due Date",
    id: "pricingDueDateWithoutDate"
  },
  pricingHasBeenSuccessfullySubmitted: {
    defaultMessage: "Pricing has been successfully submitted.",
    id: "pricingHasBeenSuccessfullySubmitted"
  },
  pricingIsCompleteForBidOwnerMessage: {
    defaultMessage:
      "Pricing is complete. Document shipper feedback or close out bid.",
    id: "pricingIsCompleteForBidOwnerMessage"
  },
  pricingIsCompleteForNonBidOwnerMessage: {
    defaultMessage:
      "Pricing is complete. Submit priced documents to shipper and inform Pricing of feedback",
    id: "pricingIsCompleteForNonBidOwnerMessage"
  },  
  pricingLaunchDate: {
    defaultMessage: "Pricing Launch Date",
    id: "pricingLaunchDate"
  },
  pricingModel: {
    defaultMessage: "Pricing Model",
    id: "pricingModel"
  },
  primary: {
    defaultMessage: "Primary",
    id: "primary"
  },
  primaryAndBackup: {
    defaultMessage: "Primary and Backup",
    id: "primaryAndBackup"
  },
  primaryBackup: {
    defaultMessage: "Primary, Backup",
    id: "primaryBackup"
  },
  primaryIncumbent: {
    defaultMessage: "Primary Incumbent",
    id: "primaryIncumbent"
  },
  primaryOnly: {
    defaultMessage: "Primary only",
    id: "primaryOnly"
  },
  primaryRef: {
    defaultMessage: "Primary Ref",
    id: "primaryRef"
  },
  primarySecondaryBackup: {
    defaultMessage: "Primary, Secondary, Backup",
    id: "primarySecondaryBackup"
  },
  processing: {
    defaultMessage: "Processing",
    id: "processing"
  },
  procurement: {
    defaultMessage: "Procurement",
    id: "procurement"
  },
  procurementRepViewReviewBannerMessage: {
    defaultMessage:
      "Carrier Match Submissions were submitted for review.  Submit Matches for the following lanes.",
    id: "procurementRepViewReviewBannerMessage"
  },
  procurementReps: {
    defaultMessage: "Procurement Reps",
    id: "procurementReps"
  },
  procurementRepresentative: {
    defaultMessage: "Procurement Representative",
    id: "procurementRepresentative"
    },
  project: {
        defaultMessage: "Project",
        id: "project"
  },
  projectedRevenue: {
    defaultMessage: "Projected Revenue",
    id: "projectedRevenue"
  },
  pwbCost: {
    defaultMessage: "PWB Cost",
    id: "pwbCost"
  },
  pwbMargin: {
    defaultMessage: "PWB Margin",
    id: "pwbMargin"
    },
  quarterly: {
    defaultMessage: "Quarterly",
    id: "quarterly"
  },
  quartile: {
    defaultMessage: "Quartile",
    id: "quartile"
  },
  quoteType: {
    defaultMessage: "Quote Type",
    id: "quoteType"
  },
  radiusMi: {
    defaultMessage: "Radius: {radius} mi",
    id: "radiusMi"
  },
  railCarrier: {
    defaultMessage: "Rail Carrier",
    id: "railCarrier"
  },
  randMcNally: {
    defaultMessage: "Rand McNally",
    id: "randMcNally"
  },
  rank: {
    defaultMessage: "Rank",
    id: "rank"
  },
  rankBreakdown: {
    defaultMessage: "Rank Breakdown",
    id: "rankBreakdown"
  },
  rankByVolume: {
    defaultMessage: "Rank by Volume",
    id: "rankByVolume"
  },
  rankInfoTooltip: {
    defaultMessage:
      "All values displayed are based off of the selected historical range",
    id: "rankInfoTooltip"
  },
  rate: {
    defaultMessage: "Rate",
    id: "rate"
  },
  rateEffectiveDate: {
    defaultMessage: "Rate Effective Date",
    id: "rateEffectiveDate"
  },
  rateEffectiveDateWithFormattedDate: {
    defaultMessage: "Rate Effective Date: {formattedDate}",
    id: "rateEffectiveDateWithFormattedDate"
  },
  rateExpirationDate: {
    defaultMessage: "Rate Expiration Date",
    id: "rateExpirationDate"
  },
  ratePerKM: {
    defaultMessage: "€ per KM",
    id: "ratePerKM"
  },
  ratePerLB: {
    defaultMessage: "$ / LB",
    id: "ratePerLB"
  },
  ratePerMile: {
    defaultMessage: "$/mile",
    id: "ratePerMile"
  },
  rateReturnFormat: {
    defaultMessage: "Rate Return Format",
    id: "rateReturnFormat"
  },
  rateType: {
    defaultMessage: "Rate Type",
    id: "rateType"
  },
  rateView: {
    defaultMessage: "RateView",
    id: "rateView"
  },
  rcKm: {
    defaultMessage: "RC km",
    id: "rcKm"
  },
  recommendedModeDocuments: {
    defaultMessage: "Recommended Mode Documents",
    id: "recommendedModeDocuments"
  },
  red: {
    defaultMessage: "Red",
    id: "red"
  },
  reefer: {
    defaultMessage: "Reefer",
    id: "reefer"
  },
  reeferContainer: {
    defaultMessage: "Reefer Container",
    id: "reeferContainer"
  },
  refresh: {
    defaultMessage: "Refresh",
    id: "refresh"
  },
  refreshMatches: {
    defaultMessage: "Refresh Matches",
    id: "refreshMatches"
  },
  region: {
    defaultMessage: "Region",
    id: "region"
  },
  regionToPoint: {
    defaultMessage: "Region To Point",
    id: "regionToPoint"
  },
  regionToRegion: {
    defaultMessage: "Region to Region",
    id: "regionToRegion"
  },
  regionToState: {
    defaultMessage: "Region To State",
    id: "regionToState"
  },
  reject: {
    defaultMessage: "Reject",
    id: "reject"
  },
  rejected: {
    defaultMessage: "Rejected",
    id: "rejected"
  },
  rejectedForCarrierMatching: {
    defaultMessage: "Rejected For Carrier Matching",
    id: "rejectedForCarrierMatching"
  },
  rejectBid: {
    defaultMessage: "Reject Bid",
    id: "rejectBid"
  },
  rejectBidMessage: {
    defaultMessage: "Please select a reason for rejecting this bid.",
    id: "rejectBidMessage"
  },
  rejectCapacityMatchMessage: {
    defaultMessage:
      "By rejecting this bid, you will be notifying pricing that procurement will not submit matches on this bid.",
    id: "rejectCapacityMatchMessage"
  },
  rejectCapacityMatchWarningMessage: {
    defaultMessage: "Are you sure you would like to reject?",
    id: "rejectCapacityMatchWarningMessage"
  },
  reload: {
    defaultMessage: "Reload",
    id: "reload"
  },
  reminder: {
    defaultMessage: "Reminder",
    id: "reminder"
  },
  removableGooseNeck: {
    defaultMessage: "Removable Goose Neck",
    id: "removableGooseNeck"
  },
  remove: {
    defaultMessage: "Remove",
    id: "Remove"
  },
  replace: {
    defaultMessage: "Replace",
    id: "replace"
  },
  reportsAndCompaniesCount: {
    defaultMessage: "{reports} Reports {companies} Companies",
    id: "reportsAndCompaniesCount"
  },
  reprice: {
    defaultMessage: "Re-price",
    id: "reprice"
  },
  requiredAnalyticsFieldsMessage: {
    defaultMessage:
      "Rank, Origin, Origin Radius, Destination, and Destination Radius are required",
    id: "requiredAnalyticsFieldsMessage"
  },
  requiresGuaranteedShipments: {
    defaultMessage: "Requires Guaranteed Shipments Y/N",
    id: "requiresGuaranteedShipments"
  },
  reset: {
    defaultMessage: "Reset",
    id: "reset"
  },
  resetColumns: {
    defaultMessage: "Reset Columns",
    id: "resetColumns"
  },
  resetFilters: {
    defaultMessage: "Reset Filters",
    id: "resetFilters"
  },
  residential: {
    defaultMessage: "Residential",
    id: "residential"
  },
  returnHome: {
    defaultMessage: "Return Home",
    id: "returnHome"
  },
  returnToForm: {
    defaultMessage: "Return To Form",
    id: "returnToForm"
  },
  returnToPendingBids: {
    defaultMessage: "Return to Pending Bids",
    id: "returnToPendingBids"
  },
  reviewAndSubmit: {
    defaultMessage: "Review & Submit",
    id: "reviewAndSubmit"
  },
  rfqCloseDate: {
    defaultMessage: "RFQ Close Date: {formattedDate}",
    id: "rfqCloseDate"
  },
  rfqCloseDateWithoutDate: {
    defaultMessage: "RFQ Close Date",
    id: "rfqCloseDateWithoutDate"
  },
  rfqManager: {
    defaultMessage: "RFQ Manager",
    id: "rfqManager"
  },
  rfqName: {
    defaultMessage: "RFQ Name",
    id: "rfqName"
  },
  rfqNameIsAlreadyInUse: {
    defaultMessage: "RFQ Name is already in use",
    id: "rfqNameIsAlreadyInUse"
  },
  rfqOpenDate: {
    defaultMessage: "RFQ Open Date",
    id: "rfqOpenDate"
  },
  rfqStatus: {
    defaultMessage: "RFQ Status",
    id: "rfqStatus"
  },
  rgnMultiAxel: {
    defaultMessage: "RGN Multi-Axel",
    id: "rgnMultiAxel"
  },
  rgnStretch: {
    defaultMessage: "RGN Stretch",
    id: "rgnStretch"
  },
  rpKm: {
    defaultMessage: "RPKm",
    id: "rpKm"
  },
  rpm: {
    defaultMessage: "RPM",
    id: "rpm"
  },
  rtrTransit: {
    defaultMessage: "RTR Transit",
    id: "rtrTransit"
  },
  roadTrain: {
    defaultMessage: "Road Train",
    id: "roadTrain"
  },
  roadtrainBox: {
    defaultMessage: "Roadtrain Box",
    id: "roadtrainBox"
  },
  roadtrainCurtain: {
    defaultMessage: "Roadtrain Curtain",
    id: "roadtrainCurtain"
  },
  role: {
    defaultMessage: "Role",
    id: "role"
  },
  rollerbedCurtain: {
    defaultMessage: "Rollerbed Curtain",
    id: "rollerbedCurtain"
  },
  round: {
    defaultMessage: "Round",
    id: "round"
  },
  round2DueDate: {
    defaultMessage: "Round 2 Due Date",
    id: "round2DueDate"
  },
  round3DueDate: {
    defaultMessage: "Round 3 Due Date",
    id: "round3DueDate"
  },
  round4DueDate: {
    defaultMessage: "Round 4 Due Date",
    id: "round4DueDate"
  },
  round5DueDate: {
    defaultMessage: "Round 5 Due Date",
    id: "round5DueDate"
  },
  roundTrip: {
    defaultMessage: "Round Trip",
    id: "roundTrip"
  },
  rowsPerPage: {
    defaultMessage: "Rows Per Page:",
    id: "rowsPerPage"
  },
  runMatching: {
    defaultMessage: "Run Matching",
    id: "runMatching"
  },
  rxo: {
    defaultMessage: "RXO",
    id: "rxo"
  },
  rxoAdditionalFee: {
    defaultMessage: "RXO Additional Fee",
    id: "rxoAdditionalFee"
  },
  rxoAdjustedMargin: {
    defaultMessage: "RXO Adjusted Margin",
    id: "rxoAdjustedMargin"
  },
  rxoAllInCustomerRate: {
    defaultMessage: "RXO All in Customer Rate",
    id: "rxoAllInCustomerRate"
  },
  rxoFuel: {
    defaultMessage: "RXO Fuel (optional)",
    id: "rxoFuel"
  },
  rxoLaneId: {
    defaultMessage: "RXO Lane ID",
    id: "rxoLaneId"
  },
  rxoUSATTTCost: {
    defaultMessage: "RXO USA TTT Cost",
    id: "rxoUSATTTCost"
  },
  rxoMargin: {
    defaultMessage: "RXO Margin",
    id: "rxoMargin"
  },
  rxoMarginPercentage: {
    defaultMessage: "RXO Margin %",
    id: "rxoMarginPercentage"
  },
  rxoMiles: {
    defaultMessage: "RXO Miles",
    id: "rxoMiles"
  },
  rxoUsaTttCostAdjusted: {
    defaultMessage: "RXO USA TTT Cost Adjusted",
    id: "rxoUsaTttCostAdjusted"
  },
  rxoUsaTttCpm: {
    defaultMessage: "RXO USA TTT CPM",
    id: "rxoUsaTttCpm"
  },
  salesforceOpportunityId: {
    defaultMessage: "Salesforce Opportunity Id",
    id: "salesforceOpportunityId"
  },
  salesforceOpportunityIdOptional: {
    defaultMessage: "Salesforce Opportunity Id (optional)",
    id: "salesforceOpportunityIdOptional"
  },
  salesManager: {
    defaultMessage: "Sales Manager",
    id: "salesManager"
  },
  salesOnly: {
    defaultMessage: "Sales Only",
    id: "salesOnly"
  },
  salesRepresentative: {
    defaultMessage: "Sales Representative",
    id: "salesRepresentative"
  },
  sameDay: {
    defaultMessage: "Same Day",
    id: "sameDay"
  },
  save: {
    defaultMessage: "Save",
    id: "save"
  },
  saveChanges: {
    defaultMessage: "Save Changes",
    id: "saveChanges"
  },
  saveLanesErrorMessage: {
    defaultMessage:
      "Sorry, error occurred while saving lanes. Please try again.",
    id: "saveLanesErrorMessage"
  },
  search: {
    defaultMessage: "Search",
    id: "search"
  },
  searchAllBids: {
    defaultMessage: "Search All Bids",
    id: "searchAllBids"
  },
  searchAllBidsSearchBoxPlaceHolder: {
    defaultMessage: "Search RFQ Name, Shipper Name, Shipper Code",
    id: "searchAllBidsSearchBoxPlaceHolder"
  },
  searchAllBidsSearchBoxPlaceHolderV2: {
    defaultMessage:
      "Search Unique Bid Name, Account Name, FO Code, Opportunity Id",
    id: "searchAllBidsSearchBoxPlaceHolderV2"
  },
  searchLanesInThisBid: {
    defaultMessage: "Search Lanes in this Bid",
    id: "searchLanesInThisBid"
  },
  searchThisPage: {
    defaultMessage: "Search This Page",
    id: "searchThisPage"
  },
  seasonalityCost: {
    defaultMessage: "Seasonality Cost",
    id: "seasonalityCost"
  },
  seasonalityCpm: {
    defaultMessage: "Seasonality CPM",
    id: "seasonalityCpm"
  },
  seasonalityCpKm: {
    defaultMessage: "Seasonality CPKm",
    id: "seasonalityCpKm"
  },
  secondary: {
    defaultMessage: "Secondary",
    id: "secondary"
  },
  seeAllNotifications: {
    defaultMessage: "See all Notifications",
    id: "seeAllNotifications"
  },
  selectAPopulatedRfqTemplateToImportLanes: {
    defaultMessage: "Select a populated RFQ Template to Import Lanes.",
    id: "selectAPopulatedRfqTemplateToImportLanes"
  },
  selectAll: {
    defaultMessage: "Select All",
    id: "selectAll"
  },
  selectBidFormat: {
    defaultMessage: "Select bid format:",
    id: "selectBidFormat"
  },
  selectAnyMatchesYouWouldLikeToApplyToThisLane: {
    defaultMessage:
      "Select any matches you would like to apply to this lane, then click “Continue”.",
    id: "selectAnyMatchesYouWouldLikeToApplyToThisLane"
  },
  selectMatchesForTheFollowingLanesBannerMessage: {
    defaultMessage:
      "Lanes were imported. Select matches for the following lanes.",
    id: "selectMatchesForTheFollowingLanesBannerMessage"
  },
  selectPertainingModes: {
    defaultMessage: "Select pertaining modes :",
    id: "selectPertainingModes"
  },
  selectTheCoyoteFormattedShipperAwardDocument: {
    defaultMessage: "Select the RXO formatted shipper award document.",
    id: "selectTheCoyoteFormattedShipperAwardDocument"
    },
  semiAnnual: {
    defaultMessage: "Semi Annual",
    id: "semiAnnual"
  },
  semiLowLoader: {
    defaultMessage: "Semi Low Loader",
    id: "semiLowLoader"
  },
  sep: {
    defaultMessage: "Sep",
    id: "sep"
  },
  send: {
    defaultMessage: "Send",
    id: "send"
  },
  sendForReview: {
    defaultMessage: "Send for Review",
    id: "sendForReview"
  },
  sendSubmissions: {
    defaultMessage: "Send Submissions",
    id: "sendSubmissions"
  },
  sendSystemNotification: {
    defaultMessage: "Send System Notification",
    id: "sendSystemNotification"
  },
  sendToPricing: {
    defaultMessage: "Send to Pricing",
    id: "sendToPricing"
  },
  serviceType: {
    defaultMessage: "Service Type",
    id: "serviceType"
  },
  settings: {
    defaultMessage: "Settings",
    id: "settings"
  },
  shipFuelIncome: {
    defaultMessage: "Ship Fuel Income",
    id: "shipFuelIncome"
  },
  shipKm: {
    defaultMessage: "Ship Km",
    id: "shipKm"
  },
  shipMi: {
    defaultMessage: "Ship Mi",
    id: "shipMi"
  },
  shipper: {
    defaultMessage: "Shipper",
    id: "shipper"
  },
  shipperCode: {
    defaultMessage: "Shipper Code",
    id: "shipperCode"
  },
  shipperHistory: {
    defaultMessage: "Shipper History",
    id: "shipperHistory"
  },
  shipperLaneId: {
    defaultMessage: "Shipper Lane ID",
    id: "shipperLaneId"
  },
  shipperName: {
    defaultMessage: "Shipper Name",
    id: "shipperName"
  },
  shipperRatesAwardTemplateEquipmentType: {
    defaultMessage: "Replace 'Van' with 'Van, Reefer' for all TL lanes?",
    id: "shipperRatesAwardTemplateEquipmentType"
  },
  shipperRatesAwardTemplateNonPrimaryLanes: {
    defaultMessage: "Include Non-Primary lanes?",
    id: "shipperRatesAwardTemplateNonPrimaryLanes"
  },
  shipperRatesAwardTemplateTitle: {
    defaultMessage: "Select options for Shipper Rates template export",
    id: "shipperRatesAwardTemplateTitle"
  },
  shipperRatesInformationFor: {
    defaultMessage: "Shipper Rates Information For:",
    id: "shipperRatesInformationFor"
  },
  shipperRatesView: {
    defaultMessage: "Shipper Rates View",
    id: "shipperRatesView"
  },
  shipperTenderStrategy: {
    defaultMessage: "Shipper Tender Strategy",
    id: "shipperTenderStrategy"
  },
  shipperToCarrierContract: {
    defaultMessage: "Shipper to Carrier Contract",
    id: "shipperToCarrierContract"
  },
  shipperView: {
    defaultMessage: "Shipper View",
    id: "shipperView"
  },
  shipTransTime: {
    defaultMessage: "Ship Trans Time",
    id: "shipTransTime"
  },
  shortLeadTime: {
    defaultMessage: "Short Lead Time",
    id: "shortLeadTime"
  },
  showMe: {
    defaultMessage: "Show Me",
    id: "showMe"
  },
  siloTanker: {
    defaultMessage: "Silo Tanker",
    id: "siloTanker"
  },
  similartoPrimaryIncumbent: {
    defaultMessage: "Similar to Primary Incumbent",
    id: "similartoPrimaryIncumbent"
  },
  skeletalContainer: {
    defaultMessage: "Skeletal (Container)",
    id: "skeletalContainer"
  },
  slicLanes: {
    defaultMessage: "SLIC Lanes:",
    id: "slicLanes"
  },
  softShell: {
    defaultMessage: "Soft Shell",
    id: "softShell"
  },
  solution: {
    defaultMessage: "Solution",
    id: "solution"
  },
  sorrySomethingWentWrong: {
    defaultMessage: "Sorry, something went wrong.",
    id: "sorrySomethingWentWrong"
  },
  sorrySomethingWentWrongPleaseTryAgain: {
    defaultMessage: "Sorry, something went wrong. Please try again.",
    id: "sorrySomethingWentWrongPleaseTryAgain"
  },
  sort: {
    defaultMessage: "Sort",
    id: "sort"
  },
  sortAndSegregate: {
    defaultMessage: "Sort and Segregate",
    id: "sortAndSegregate"
  },
  sortBy: {
    defaultMessage: "Sort by",
    id: "sortBy"
  },
  spinner: {
    defaultMessage: "Spinner",
    id: "spinner"
  },
  spot: {
    defaultMessage: "Spot",
    id: "spot"
  },
  st: {
    defaultMessage: "St",
    id: "st"
  },
  startDate: {
    defaultMessage: "Start Date",
    id: "startDate"
  },
  startingMonth: {
    defaultMessage: "Starting Month",
    id: "startingMonth"
  },
  stateCode: {
    defaultMessage: "State Code",
    id: "stateCode"
  },
  stateToPoint: {
    defaultMessage: "State To Point",
    id: "stateToPoint"
  },
  stateToRegion: {
    defaultMessage: "State to Region",
    id: "stateToRegion"
  },
  stateToState: {
    defaultMessage: "State to State",
    id: "stateToState"
  },
  status: {
    defaultMessage: "Status",
    id: "status"
  },
  stay: {
    defaultMessage: "Stay",
    id: "stay"
  },
  stepDeck: {
    defaultMessage: "Step-Deck",
    id: "stepDeck"
  },
  stepdeckStretch: {
    defaultMessage: "Step Deck Stretch",
    id: "stepdeckStretch"
  },
  stepdeckWithRamps: {
    defaultMessage: "Stepdeck With Ramps",
    id: "stepdeckWithRamps"
  },
  stepframeBox: {
    defaultMessage: "Stepframe Box",
    id: "stepframeBox"
  },
  stepframeCurtain: {
    defaultMessage: "Stepframe Curtain",
    id: "stepframeCurtain"
  },
  stopNotification: {
    defaultMessage: "Stop Notification",
    id: "stopNotification"
  },
  strategicEffectiveEndDate: {
    defaultMessage: "Strategic Effective End Date",
    id: "strategicEffectiveEndDate"
  },
  strategicEffectiveStartDate: {
    defaultMessage: "Strategic Effective Start Date",
    id: "strategicEffectiveStartDate"
  },
  strategicPeriodTTTCost: {
    defaultMessage: "Strategic Period TTT Cost",
    id: "strategicPeriodTTTCost"
  },
  strategicQuantile: {
    defaultMessage: "Strategic Quantile",
    id: "strategicQuantile"
  },
  strategicQuantileOptional: {
    defaultMessage: "Strategic Quantile (Optional)",
    id: "strategicQuantileOptional"
  },
  strategicTTTCost: {
    defaultMessage: "Strategic TTT Cost",
    id: "strategicTTTCost"
  },
  strategicQuantileValidationMessage: {
    defaultMessage: "Value must be between {minValue}% and {maxValue}%",
    id: "strategicQuantileValidationMessage"
  },
  strategyDuration: {
    defaultMessage: "Strategy Duration",
    id: "strategyDuration"
  },
  strategyDurationOptional: {
    defaultMessage: "Strategy Duration (optional)",
    id: "strategyDurationOptional"
  },
  strategyNotes: {
    defaultMessage: "Strategy Notes",
    id: "strategyNotes"
  },
  strategyNotesOptional: {
    defaultMessage: "Strategy Notes (optional)",
    id: "strategyNotesOptional"
  },
  strategySelectionModalBodyMessage: {
    defaultMessage: "Select the strategy for this bid.",
    id: "strategySelectionModalBodyMessage"
  },
  success: {
    defaultMessage: "Success!",
    id: "success"
  },
  submissionComplete: {
    defaultMessage: "Submission Complete!",
    id: "submissionComplete"
  },
  submitPricing: {
    defaultMessage: "Submit Pricing",
    id: "submitPricing"
  },
  submitPricingModalBodyMessage: {
    defaultMessage:
      "Upload a priced bid document in the shipper format. The Sales rep will be prompted to submit the bid to the shipper upon submission.",
    id: "submitPricingModalBodyMessage"
  },
  submitPricingModalCheckboxMessage: {
    defaultMessage:
      "I have already shared a shipper-formatted priced document in Attachments.",
    id: "submitPricingModalCheckboxMessage"
  },
  submitted: {
    defaultMessage: "Submitted",
    id: "submitted"
  },
  summary: {
    defaultMessage: "Summary",
    id: "summary"
  },
  systemError: {
    defaultMessage: "System Error",
    id: "systemError"
  },
  systemErrorMessage: {
    defaultMessage:
      "Sorry, something went wrong. Please try again. If you exit, your changes will not be saved.",
    id: "systemErrorMessage"
  },
  systemFailedToRetrieveMainRepOnFile: {
    defaultMessage: "System failed to retrieve main rep on file. Try again",
    id: "systemFailedToRetrieveMainRepOnFile"
  },
  systemMessageFormat: {
    defaultMessage: "{action} by {userName} on {date}",
    id: "systemMessageFormat"
  },
  systemMessageRejectedFormat: {
    defaultMessage:
      "{action} by {userName} on {date}. Please either self-price or close the bid.",
    id: "systemMessageRejectedFormat"
  },
  systemNotificationSentSuccessfully: {
    defaultMessage: "System Notification sent successfully",
    id: "systemNotificationSentSuccessfully"
  },
  systemNotificationValidationMessage: {
    defaultMessage: "Reduce HTML payload/message size",
    id: "systemNotificationValidationMessage"
  },
  systemSuccess: {
    defaultMessage: "System Success",
    id: "systemSuccess"
  },
  systemUpdates: {
    defaultMessage: "System Updates",
    id: "systemUpdates"
  },
  tags: {
    defaultMessage: "Tags",
    id: "tags"
  },
  tanker: {
    defaultMessage: "Tanker",
    id: "tanker"
  },
  tankerChemicals: {
    defaultMessage: "Tanker (Chemicals)",
    id: "tankerChemicals"
  },
  tankerEndorsement: {
    defaultMessage: "Tanker Endorsement",
    id: "tankerEndorsement"
  },
  tankerFood: {
    defaultMessage: "Tanker (Food)",
    id: "tankerFood"
  },
  target: {
    defaultMessage: "Target",
    id: "target"
  },
  targetRate: {
    defaultMessage: "Target Rate",
    id: "targetRate"
  },
  targetType: {
    defaultMessage: "Target Type",
    id: "targetType"
  },
  team: {
    defaultMessage: "Team",
    id: "team"
  },
  teamEdit: {
    defaultMessage: "Team Edit",
    id: "teamEdit"
  },
  teamEditModalBodyMessage: {
    defaultMessage:
      "Select a name to transfer bid ownership or add names to tag additional users.",
    id: "teamEditModalBodyMessage"
  },
  tempReq: {
    defaultMessage: "Temp Req",
    id: "tempReq"
  },
  templateDownload: {
    defaultMessage: "Template Download",
    id: "templateDownload"
  },
  tenderAcceptanceParameters: {
    defaultMessage: "Tender Acceptance Parameters (optional)",
    id: "tenderAcceptanceParameters"
  },
  theNextRoundHasBeenSuccessfullyOpened: {
    defaultMessage: "The next round has been successfully opened.",
    id: "theNextRoundHasBeenSuccessfullyOpened"
  },
  thisBidHasBeenRejectedMessage: {
    defaultMessage:
      "This bid has been rejected. You can view this bid under Search.",
    id: "thisBidHasBeenRejectedMessage"
  },
  thisBidHasNotYetBeenAcceptedForPricing: {
    defaultMessage: "This bid has not yet been accepted for pricing.",
    id: "thisBidHasNotYetBeenAcceptedForPricing"
  },
  thisBidIncludesTheFollowingAdditionalModes: {
    defaultMessage: "This bid includes the following additional modes:",
    id: "thisBidIncludesTheFollowingAdditionalModes"
  },
  thisCannotBeUndone: {
    defaultMessage: "This cannot be undone.",
    id: "thisCannotBeUndone"
  },
  thisFieldIsRequired: {
    defaultMessage: "This field is required",
    id: "thisFieldIsRequired"
  },
  roundCloseDateMustBeAfterRfqCloseDate: {
    defaultMessage: "Must be on or after RFQ close date",
    id: "roundCloseDateMustBeAfterRfqCloseDate"
  },
  thisMessageCouldNotBeDelivered: {
    defaultMessage: "This message could not be delievered.",
    id: "thisMessageCouldNotBeDelivered"
  },
  thisUserHasAlreadyBeenSelected: {
    defaultMessage: "This user has already been selected",
    id: "thisUserHasAlreadyBeenSelected"
  },
  throughTrailer: {
    defaultMessage: "ThroughTrailer",
    id: "throughTrailer"
  },
  thumbsDown: {
    defaultMessage: "Thumbs down",
    id: "thumbsDown"
  },
  tilt: {
    defaultMessage: "Tilt",
    id: "tilt"
  },
  time: {
    defaultMessage: "Time",
    id: "time"
  },
  timeline: {
    defaultMessage: "Timeline",
    id: "timeline"
  },
  timeSinceLastUpdate: {
    defaultMessage: "Time since last update",
    id: "timeSinceLastUpdate"
  },
  timeSinceLastUpdateDuration: {
    defaultMessage: "{timeSinceLastUpdateDuration}",
    id: "timeSinceLastUpdateDuration"
  },
  timeSinceLastUpdateDurationAgo: {
    defaultMessage: "{timeSinceLastUpdateDurationAgo} ago",
    id: "timeSinceLastUpdateDurationAgo"
  },
  tl: {
    defaultMessage: "TL",
    id: "tl"
  },
  tlFileName: {
    defaultMessage: "Truckload Lane Import Template.xlsx",
    id: "tlFileName"
  },
  tlFileNameV2: {
    defaultMessage: "Truckload Lane Import Template V2.xlsx",
    id: "tlFileNameV2"
  },
  tlnPlanner: {
    defaultMessage: "TLN Planner",
    id: "tlnPlanner"
  },
  tlPricing: {
    defaultMessage: "TL Pricing",
    id: "tlPricing"
  },
  tlPricingAnalyst: {
    defaultMessage: "TL Pricing Analyst",
    id: "tlPricingAnalyst"
  },
  to: {
    defaultMessage: "to",
    id: "to"
  },
  toViewDetails: {
    defaultMessage: "to view details",
    id: "toViewDetails"
  },
  totCost: {
    defaultMessage: "Tot Cost",
    id: "totCost"
  },
  totRate: {
    defaultMessage: "Tot Rate",
    id: "totRate"
  },
  totalRev: {
    defaultMessage: "Tot Rev",
    id: "totalRev"
  },
  totalLane: {
    defaultMessage: "Total Lane: {totalFiltered}",
    id: "totalLane"
  },
  totalLanes: {
    defaultMessage: "Total Lanes",
    id: "totalLanes"
  },
  totalLanesCount: {
    defaultMessage: "{totalLanesCount} Total Lanes",
    id: "totalLanesCount"
  },
  tradeLanes: {
    defaultMessage: "Trade Lanes",
    id: "tradeLanes"
  },
  tradeshow: {
    defaultMessage: "Tradeshow",
    id: "tradeshow"
  },
  trafficLight: {
    defaultMessage: "Traffic Light",
    id: "trafficLight"
  },
  transldFee: {
    defaultMessage: "Transld Fee",
    id: "transldFee"
  },
  transloadByCoyote: {
    defaultMessage: "Transload By Coyote",
    id: "transloadByCoyote"
  },
  transloadByShipper: {
    defaultMessage: "Transload By Shipper",
    id: "transloadByShipper"
  },
  truckload: {
    defaultMessage: "Truckload",
    id: "truckload"
  },
  tryagain: {
    defaultMessage: "Try again",
    id: "tryagain"
  },
  tryAgain: {
    defaultMessage: "Try Again",
    id: "tryAgain"
  },
  tttCost: {
    defaultMessage: "TTT Cost",
    id: "tttCost"
  },
  typeSomething: {
    defaultMessage: "Type something",
    id: "typeSomething"
  },
  twic: {
    defaultMessage: "TWIC",
    id: "twic"
  },
  typicalPalletCountOptional: {
    defaultMessage: "Typical Pallet Count (optional)",
    id: "typicalPalletCountOptional"
  },
  unableToPerformActionMessage: {
    defaultMessage:
      "Sorry, we were unable to perform that action. Please try again.",
    id: "unableToPerformActionMessage"
  },
  unableToRetrieveData: {
    defaultMessage: "Unable to retrieve data.",
    id: "unableToRetrieveData"
  },
  unchecked: {
    defaultMessage: "Unchecked",
    id: "unchecked"
  },
  uniqueBidName: {
    defaultMessage: "Unique Bid Name",
    id: "uniqueBidName"
  },
  uniqueBidNameIsAlreadyInUse: {
    defaultMessage: "Unique Bid Name is already in use",
    id: "uniqueBidNameIsAlreadyInUse"
  },
  unmatchedLanes: {
    defaultMessage: "Unmatched Lanes",
    id: "unmatchedLanes"
  },
  unmatchedLanesConfirmationMessage: {
    defaultMessage:
      'You are about to submit {noOfLanes} lanes that have not yet been matched. {br}By continuing, unmatched lanes will show as "None".',
    id: "unmatchedLanesConfirmationMessage"
  },
  unsavedChanges: {
    defaultMessage: "Unsaved Changes",
    id: "unsavedChanges"
  },
  updateThePricingDueDateWithTheNextRoundDueDate: {
    defaultMessage:
      "Update the Pricing Due Date with the next round’s due date.",
    id: "updateThePricingDueDateWithTheNextRoundDueDate"
  },
  updateTheRfqCloseDateWithTheNextRoundCloseDate: {
    defaultMessage:
      "Update the RFQ Close Date with the next round’s close date.",
    id: "updateTheRfqCloseDateWithTheNextRoundCloseDate"
  },
  upload: {
    defaultMessage: "Upload",
    id: "upload"
  },
  uploadAward: {
    defaultMessage: "Upload Award",
    id: "uploadAward"
  },
  uploadComplete: {
    defaultMessage: "Upload Complete!",
    id: "uploadComplete"
  },
  uploadLaneForNonTLUserSuccessMessage: {
    defaultMessage: "Thanks for your patience. Your lane import is complete.",
    id: "uploadLaneForNonTLUserSuccessMessage"
  },
  uploadLaneForTLUserSuccessMessage: {
    defaultMessage:
      "Thanks for your patience. Lane assignements can be edited from the Assignments widget in the Summary page.",
    id: "uploadLaneForTLUserSuccessMessage"
  },
  uploadLaneProgressMessage: {
    defaultMessage:
      "Please wait while we set things up for you! Exiting this page or closing the browser will cause the import to fail.",
    id: "uploadLaneProgressMessage"
  },
  uploadLaneSystemErrorMessage: {
    defaultMessage:
      "Sorry, something went wrong. Please try again or cancel to select a different document.",
    id: "uploadLaneSystemErrorMessage"
  },
  uploadLaneValidationMessage: {
    defaultMessage:
      "Uh oh, we ran into some errors. You can download a document highlighting the errors below. Please note that lanes without errors have been successfully imported.",
    id: "uploadLaneValidationMessage"
  },
  uploadTheFeedbackReceivedFromTheShipper: {
    defaultMessage: "Upload the feedback received from the shipper.",
    id: "uploadTheFeedbackReceivedFromTheShipper"
  },
  uploadTheShipperAwardDocument: {
    defaultMessage: "Upload the shipper award document.",
    id: "uploadTheShipperAwardDocument"
  },
  uploadedByUser: {
    defaultMessage: "Uploaded by : {userName}",
    id: "uploadedByUser"
  },
  uploadYourFilesHereOr: {
    defaultMessage: "Upload your files here or ",
    id: "uploadYourFilesHereOr"
  },
  ups: {
    defaultMessage: "UPS",
    id: "ups"
  },
  upsCarriersCount: {
    defaultMessage: "{noOfUPSCarriers} UPS",
    id: "upsCarriersCount"
  },
  user: {
    defaultMessage: "User",
    id: "user"
  },
  userRoleToView: {
    defaultMessage: "User Role to View",
    id: "userRoleToView"
  },
  users: {
    defaultMessage: "Users",
    id: "users"
  },
  useCoyoteFsc: {
    defaultMessage: "Use Coyote FSC",
    id: "useCoyoteFsc"
  },
  van: {
    defaultMessage: "Van",
    id: "van"
  },
  validationError: {
    defaultMessage: "Validation Error",
    id: "validationError"
  },
  ventedVan: {
    defaultMessage: "Vented Van",
    id: "ventedVan"
  },
  view: {
    defaultMessage: "View",
    id: "view"
  },
  viewDATRateView: {
    defaultMessage: "View DAT RateView",
    id: "viewDATRateView"
  },
  viewMatches: {
    defaultMessage: "View Matches ({matches})",
    id: "viewMatches"
  },
  viewRateHistory: {
    defaultMessage: "View Rate History",
    id: "viewRateHistory"
  },
  vol: {
    defaultMessage: "Vol",
    id: "vol"
  },
  volume: {
    defaultMessage: "Volume",
    id: "volume"
  },
  volumeToCarrier: {
    defaultMessage: "Volume to Carrier",
    id: "volumeToCarrier"
  },
  walkingFloorBox: {
    defaultMessage: "Walking Floor Box",
    id: "walkingFloorBox"
  },
  warning: {
    defaultMessage: "Warning",
    id: "warning"
  },
  waterfallRank1To50: {
    defaultMessage: "Waterfall (Rank 1 to 50)",
    id: "waterfallRank1To50"
  },
  weeklyCap: {
    defaultMessage: "Weekly Cap.",
    id: "weeklyCap"
  },
  weight: {
    defaultMessage: "Weight",
    id: "weight"
  },
  weightUom: {
    defaultMessage: "Weight UOM",
    id: "weightUom"
  },
  word: {
    defaultMessage: "Word",
    id: "word"
  },
  wouldYouLikeToRunMatchesBannerMessage: {
    defaultMessage:
      "Lanes were imported. Would you like to run matches for this bid?",
    id: "wouldYouLikeToRunMatchesBannerMessage"
  },
  yellow: {
    defaultMessage: "Yellow",
    id: "yellow"
  },
  yes: {
    defaultMessage: "Yes",
    id: "yes"
  },
  youAreAboutToLoseYourEdits: {
    defaultMessage: "You are about to lose your edits.",
    id: "youAreAboutToLoseYourEdits"
  },
  youAreCaughtUp: {
    defaultMessage: "You're caught up",
    id: "youAreCaughtUp"
  },
  noPermissionToViewPage: {
    defaultMessage: "You do not have permission to view this page.",
    id: "noPermissionToViewPage"
  },
  noPermissionToEditTeam: {
    defaultMessage: "You do not have permission to edit the team on this bid.",
    id: "noPermissionToEditTeam"
  },
    bidSubmissionDetails: {
    defaultMessage: "Bid Submission Details",
    id: "bidSubmissionDetails"
  },
  bidSubmissionInformation: {
    defaultMessage: "Bid Submission Information",
    id: "bidSubmissionInformation"
  },
  bidSubmissionType: {
    defaultMessage: "Bid Submission Type",
    id: "bidSubmissionType"
  },
  bidLoginDetails: {
    defaultMessage: "Bid Login Details",
    id: "bidLoginDetails"
  },
  bidSite: {
    defaultMessage: "Bid Site",
    id: "bidSite"
  }  
});